(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wd-about-brands"] && !Shopify.designMode) return;
  try {
    
(function(){
  function bindBrands(){
    document.querySelectorAll('.wd-about-brands .js-brand').forEach(function(el){
      if(el.dataset.wdBrandBound) return;
      el.dataset.wdBrandBound = 'true';
      try{if(sessionStorage.getItem('wdBrandActive') === el.getAttribute('href')) el.classList.add('active');}catch(error){}
      el.addEventListener('click', function(){
        try{sessionStorage.setItem('wdBrandActive', el.getAttribute('href'));}catch(error){}
      });
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindBrands, {once:true});
  else bindBrands();
  document.addEventListener('shopify:section:load', bindBrands);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-about-team"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){

if(!root || root.dataset.wdBound === 'true') return;
root.dataset.wdBound = 'true';

root.addEventListener('click', function(e){
  var btnFlip = e.target.closest('[data-wd-team-flip]');
  var btnBack = e.target.closest('[data-wd-team-back]');
  if(!btnFlip && !btnBack) return;

  var card = e.target.closest('[data-wd-team-card]');
  if(!card) return;

  if(btnFlip){
    card.classList.add('is-flipped');
    return;
  }
  if(btnBack){
    card.classList.remove('is-flipped');
    return;
  }
});

root.addEventListener('keydown', function(e){
  if(e.key !== 'Enter' && e.key !== ' ') return;
  var btn = e.target.closest('[data-wd-team-flip],[data-wd-team-back]');
  if(!btn) return;
  e.preventDefault();
  btn.click();
});
    
  }
  function initAll(scope){var b=scope&&scope.querySelectorAll?scope:document;b.querySelectorAll('.wd-about-team').forEach(init);if(scope&&scope.matches&&scope.matches('.wd-about-team'))init(scope);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initAll(document);},{once:true});else initAll(document);
  document.addEventListener('shopify:section:load',function(e){initAll(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-author-articles"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(wdSection){

if(!wdSection || wdSection.dataset.wdBound === 'true') return;
wdSection.dataset.wdBound = 'true';

      var wdButton = wdSection.querySelector('[data-wd-show-all]');
      if(!wdButton){ return; }

      wdButton.addEventListener('click', function(){
        var wdHidden = wdSection.querySelectorAll('[data-wd-card][hidden]');

        for(var wdIndex = 0; wdIndex < wdHidden.length; wdIndex++){
          wdHidden[wdIndex].removeAttribute('hidden');
        }

        wdButton.setAttribute('aria-expanded', 'true');

        var wdActions = wdButton.closest('.wd-author-articles__actions');
        if(wdActions){ wdActions.remove(); }
      });
    
  }
  function initAll(scope){var b=scope&&scope.querySelectorAll?scope:document;b.querySelectorAll('.wd-author-articles').forEach(init);if(scope&&scope.matches&&scope.matches('.wd-author-articles'))init(scope);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initAll(document);},{once:true});else initAll(document);
  document.addEventListener('shopify:section:load',function(e){initAll(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-blog-index"] && !Shopify.designMode) return;
  try {
    

(() => {

  const init = (root) => {

    const sectionId = root.getAttribute('data-section-id') || '';

    if (!sectionId || root.dataset.blogIndexBound === '1') {
      return;
    }

    root.dataset.blogIndexBound = '1';


    const input = root.querySelector(
      '#wk-blog-search-' + sectionId
    );

    const grid = root.querySelector(
      '#wk-blog-grid-' + sectionId
    );

    const live = root.querySelector(
      '#wk-search-status-' + sectionId
    );

    const resultsEl = root.querySelector(
      '#wk-results-' + sectionId
    );

    const noResEl = root.querySelector(
      '#wk-noresults-' + sectionId
    );

    const noResReset = root.querySelector(
      '#wk-noresults-reset-' + sectionId
    );

    const pills = Array.from(
      root.querySelectorAll('.wk-pill')
    );


    if (!grid) {
      return;
    }


    const cards = Array.from(
      grid.querySelectorAll('.wk-card')
    );


    let activeCat = 'all';


    const normalize = (value) => {

      return (value || '')
        .toString()
        .trim()
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '');

    };


    const setPillActive = (val) => {

      activeCat = normalize(
        val || 'all'
      ) || 'all';


      pills.forEach((p) => {

        const pillVal = normalize(
          p.dataset.pill || 'all'
        ) || 'all';

        const isOn = pillVal === activeCat;

        p.classList.toggle(
          'is-active',
          isOn
        );

        p.setAttribute(
          'aria-pressed',
          isOn ? 'true' : 'false'
        );

      });

    };


    const getQuery = () => {

      return normalize(
        input ? input.value : ''
      );

    };


    const apply = () => {

      const q = getQuery();

      let shown = 0;


      cards.forEach((c) => {

        const cat = normalize(
          c.dataset.cat || ''
        );


        const hay = normalize(
          (c.dataset.title || '') + ' ' +
          (c.dataset.excerpt || '') + ' ' +
          (c.dataset.author || '') + ' ' +
          (c.dataset.catLabel || '')
        );


        const okSearch =
          !q ||
          hay.includes(q);


        const okCat =
          activeCat === 'all' ||
          cat === activeCat;


        const vis =
          okSearch &&
          okCat;


        c.style.display =
          vis
            ? ''
            : 'none';


        if (vis) {
          shown++;
        }

      });


      const txt =
        shown +
        ' ' +
        (
          root.getAttribute('data-results-word') ||
          'results'
        );


      if (live) {
        live.textContent = txt;
      }


      if (resultsEl) {
        resultsEl.textContent = txt;
      }


      if (noResEl) {

        noResEl.classList.toggle(
          'is-on',
          shown === 0
        );

      }

    };


    const resetAll = () => {

      if (input) {
        input.value = '';
      }


      setPillActive('all');

      apply();


      if (input) {
        input.focus();
      }

    };


    let t = null;


    if (input) {

      input.addEventListener(
        'input',
        () => {

          clearTimeout(t);

          t = setTimeout(
            apply,
            120
          );

        }
      );

    }


    pills.forEach((p) => {

      p.addEventListener(
        'click',
        () => {

          setPillActive(
            p.dataset.pill || 'all'
          );

          apply();

        }
      );

    });


    if (noResReset) {

      noResReset.addEventListener(
        'click',
        resetAll
      );

    }


    setPillActive('all');

    apply();

  };


  const initAll = (scope) => {

    const c =
      scope &&
      scope.querySelectorAll
        ? scope
        : document;


    c
      .querySelectorAll(
        '.wk-blog-index[data-section-id]'
      )
      .forEach(init);


    if (
      scope &&
      scope.matches &&
      scope.matches(
        '.wk-blog-index[data-section-id]'
      )
    ) {

      init(scope);

    }

  };


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      () => initAll(document),
      {
        once:true
      }
    );

  } else {

    initAll(document);

  }


  document.addEventListener(
    'shopify:section:load',
    (event) => initAll(event.target)
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-bought-together"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){

if(!root || root.dataset.bound === 'true') return;
root.dataset.bound = 'true';

var config = {};
var configEl = root.querySelector('[data-wkfbt-config]');
if(configEl){
  try{ config = JSON.parse(configEl.textContent || '{}'); }catch(e){}
}
var VAT_FACTOR = Number(config.vatFactor || ((100 + Number(config.vatRate == null || config.vatRate === '' ? 21 : config.vatRate)) / 100));
var TAXES_INCLUDED = config.taxesIncluded === true || config.taxesIncluded === 'true';

function qs(sel){ return root.querySelector(sel); }
function qsa(sel){ return Array.prototype.slice.call(root.querySelectorAll(sel)); }

var cards = qsa('.wkfbt-card');
var totalInclEl = qs('[data-wkfbt-total-incl]');
var totalExclEl = qs('[data-wkfbt-total-excl]');
var btn = qs('[data-wkfbt-add]');
var msg = qs('[data-wkfbt-msg]');
if(cards.length === 0) return;

function formatMoney(cents){
  try{
    var fmt = new Intl.NumberFormat(config.locale || 'nl-NL', { style:'currency', currency: config.currency || 'EUR' });
    return fmt.format((cents||0)/100);
  }catch(e){
    var v = (cents||0)/100;
    return '€' + v.toFixed(2).replace('.',',');
  }
}

function setMsg(text){
  if(!msg) return;
  if(!text){
    msg.hidden = true;
    msg.textContent = '';
    return;
  }
  msg.hidden = false;
  msg.textContent = text;
}

function getSelected(){
  return cards
    .map(function(card){
      var inp = card.querySelector('.wkfbt-input');
      var checked = inp ? inp.checked : false;
      var variant = card.getAttribute('data-variant');
      var price = parseInt(card.getAttribute('data-price') || '0', 10);
      return { checked: checked, variant: variant, price: price };
    })
    .filter(function(x){ return x.checked && x.variant; });
}

function updateTotal(){
  var selected = getSelected();
  var rawTotal = selected.reduce(function(a,b){ return a + (b.price||0); }, 0);
  var sumIncl = TAXES_INCLUDED ? rawTotal : Math.round(rawTotal * (VAT_FACTOR || 1));
  var sumExcl = TAXES_INCLUDED ? Math.round(rawTotal / (VAT_FACTOR || 1)) : rawTotal;

  if(totalInclEl) totalInclEl.textContent = formatMoney(sumIncl);
  if(totalExclEl) totalExclEl.textContent = formatMoney(sumExcl);

  if(btn) btn.disabled = selected.length === 0;
}

cards.forEach(function(card){
  var inp = card.querySelector('.wkfbt-input');
  if(!inp) return;
  inp.addEventListener('change', function(){
    setMsg('');
    updateTotal();
  });
});

updateTotal();

async function addItems(items){
  var payload = { items: items.map(function(it){ return { id: Number(it.variant), quantity: 1 }; }) };
  var res = await fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify(payload)
  });
  if(!res.ok){
    var t = '';
    try{ t = await res.text(); }catch(e){}
    throw new Error(t || config.addErrorLabel || 'Could not add items.');
  }
  return res.json();
}

if(btn){
  btn.addEventListener('click', async function(){
    setMsg('');
    var selected = getSelected();
    if(selected.length === 0) return;

    btn.disabled = true;
    btn.textContent = config.loadingLabel || 'Adding...';

    try{
      await addItems(selected);
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles:true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles:true }));
      document.dispatchEvent(new CustomEvent('wd:cart-added', { bubbles:true }));
      setMsg(config.successLabel || 'Added.');
      if(window.WDAnalytics && typeof window.WDAnalytics.push === 'function'){
        window.WDAnalytics.push('frequently_bought_together_add', {
          selected_count:selected.length,
          form_status:'success'
        });
      }
    }catch(err){
      setMsg(config.errorLabel || 'Something went wrong. Please try again.');
    }finally{
      btn.textContent = config.buttonLabel || 'Add selected';
      updateTotal();
    }
  });
}
    
  }
  function initAll(scope){
    var base = scope && scope.querySelectorAll ? scope : document;
    base.querySelectorAll('.wkfbt').forEach(init);
    if(scope && scope.matches && scope.matches('.wkfbt')) init(scope);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ initAll(document); }, { once:true });
  else initAll(document);
  document.addEventListener('shopify:section:load', function(event){ initAll(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-brand-series-grid"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){

if(!root || root.dataset.wdBound === 'true') return;
root.dataset.wdBound = 'true';

var track = root.querySelector('[data-wk-swipe]');
if(!track) return;

var slides = Array.prototype.slice.call(root.querySelectorAll('[data-wk-slide]'));
var dotsWrap = root.querySelector('[data-wk-dots]');

function isMobile(){
  return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
}

function buildDots(){
  if(!dotsWrap) return;
  dotsWrap.innerHTML = '';
  if(!isMobile()) return;
  if(slides.length <= 1) return;

  slides.forEach(function(_, idx){
    var d = document.createElement('span');
    d.className = 'wk-dot' + (idx === 0 ? ' is-active' : '');
    d.setAttribute('data-idx', String(idx));
    dotsWrap.appendChild(d);
  });
}

function setActiveDot(activeIdx){
  if(!dotsWrap) return;
  var dots = dotsWrap.querySelectorAll('.wk-dot');
  for(var i=0; i<dots.length; i++){
    dots[i].classList.toggle('is-active', i === activeIdx);
  }
}

function activeIndexFromScroll(){
  if(!isMobile()) return 0;
  var left = track.scrollLeft;
  var bestIdx = 0;
  var bestDist = Infinity;

  for(var i=0; i<slides.length; i++){
    var dist = Math.abs(slides[i].offsetLeft - left);
    if(dist < bestDist){
      bestDist = dist;
      bestIdx = i;
    }
  }
  return bestIdx;
}

var raf = null;
function onScroll(){
  if(!isMobile()) return;
  if(raf) cancelAnimationFrame(raf);
  raf = requestAnimationFrame(function(){
    setActiveDot(activeIndexFromScroll());
  });
}

function onResize(){
  buildDots();
  setActiveDot(activeIndexFromScroll());
}

buildDots();
setActiveDot(0);

track.addEventListener('scroll', onScroll, { passive: true });
window.addEventListener('resize', onResize);
    
  }
  function initAll(scope){
    var base = scope && scope.querySelectorAll ? scope : document;
    base.querySelectorAll('.wk-subcats').forEach(init);
    if(scope && scope.matches && scope.matches('.wk-subcats')) init(scope);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ initAll(document); }, { once:true });
  else initAll(document);
  document.addEventListener('shopify:section:load', function(event){ initAll(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-collection-usps"] && !Shopify.designMode) return;
  try {
    
(function(){
  var selector = '[data-wk-usp-rotator]';

  function init(root){
    if(!root || root.getAttribute('data-wd-usp-init') === 'true') return;
    root.setAttribute('data-wd-usp-init', 'true');

    var items = Array.prototype.slice.call(root.querySelectorAll('.wk-item'));
    if(!items.length) return;

    var mql = window.matchMedia ? window.matchMedia('(max-width: 899px)') : null;
    var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches:false };
    var intervalMs = parseInt(root.getAttribute('data-interval') || '5000', 10);
    if(!intervalMs || intervalMs < 1600) intervalMs = 5000;

    var timer = null;
    var idx = 0;
    var animMs = reduce.matches ? 0 : 360;
    var cooldownMs = reduce.matches ? 0 : 140;
    var lock = false;
    var cleanup = [];

    function listen(target, type, handler, options){
      if(!target || !target.addEventListener) return;
      target.addEventListener(type, handler, options);
      cleanup.push(function(){ target.removeEventListener(type, handler, options); });
    }

    function clearStates(){
      for(var n=0;n<items.length;n++){
        items[n].classList.remove('is-active', 'is-leaving');
      }
    }

    function show(i){
      if(!mql || !mql.matches){
        clearStates();
        return;
      }
      if(lock) return;
      lock = true;

      var current = root.querySelector('.wk-item.is-active');
      var nextEl = items[i];
      if(!nextEl){ lock = false; return; }

      if(current === nextEl){
        lock = false;
        return;
      }

      if(current){
        current.classList.add('is-leaving');
        current.classList.remove('is-active');
        window.setTimeout(function(){ current.classList.remove('is-leaving'); }, animMs + 40);
      }

      window.requestAnimationFrame(function(){
        nextEl.classList.add('is-active');
        idx = i;
        window.setTimeout(function(){ lock = false; }, animMs + cooldownMs);
      });
    }

    function stop(){
      if(timer){ window.clearInterval(timer); timer = null; }
    }

    function start(){
      stop();
      if(!mql || !mql.matches || items.length <= 1 || document.hidden) return;
      timer = window.setInterval(function(){ show((idx + 1) % items.length); }, intervalMs);
    }

    function sync(){
      stop();
      clearStates();
      idx = 0;
      if(mql && mql.matches){
        items[0].classList.add('is-active');
        start();
      }
    }

    items.forEach(function(el, i){
      listen(el, 'focusin', function(){ if(mql && mql.matches){ show(i); stop(); } });
      listen(el, 'pointerenter', function(){ if(mql && mql.matches) stop(); }, { passive:true });
      listen(el, 'pointerleave', function(){ if(mql && mql.matches) start(); }, { passive:true });
    });

    if(mql){
      if(mql.addEventListener){
        mql.addEventListener('change', sync);
        cleanup.push(function(){ mql.removeEventListener('change', sync); });
      }else if(mql.addListener){
        mql.addListener(sync);
        cleanup.push(function(){ mql.removeListener(sync); });
      }
    }

    listen(document, 'visibilitychange', function(){ if(document.hidden) stop(); else start(); });

    root.__wdUspCleanup = function(){
      stop();
      cleanup.forEach(function(fn){ try{ fn(); }catch(e){} });
      cleanup = [];
      root.removeAttribute('data-wd-usp-init');
      delete root.__wdUspCleanup;
    };

    sync();
  }

  function initWithin(scope){
    var base = scope || document;
    if(base.matches && base.matches(selector)) init(base);
    var roots = base.querySelectorAll ? base.querySelectorAll(selector) : [];
    for(var i=0;i<roots.length;i++) init(roots[i]);
  }

  initWithin(document);

  document.addEventListener('shopify:section:load', function(event){ initWithin(event.target); });
  document.addEventListener('shopify:section:unload', function(event){
    var root = event.target && event.target.querySelector ? event.target.querySelector(selector) : null;
    if(root && typeof root.__wdUspCleanup === 'function') root.__wdUspCleanup();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-contact-options"] && !Shopify.designMode) return;
  try {
    
(function(){function init(root){

if(!root || root.dataset.wdTopBound === 'true') return;
root.dataset.wdTopBound = 'true';
var btn = root.querySelector('[data-wd-top]');
if(!btn) return;

var showAt = parseInt(root.getAttribute('data-wd-top-show-at') || '700',10);
var ticking = false;

function onScroll(){
  if(ticking) return;
  ticking = true;
  window.requestAnimationFrame(function(){
    var y = window.scrollY || document.documentElement.scrollTop || 0;
    btn.hidden = !(y > showAt);
    ticking = false;
  });
}

btn.addEventListener('click', function(){
  window.scrollTo({ top: 0, behavior: 'smooth' });
});

window.addEventListener('scroll', onScroll, { passive: true });
onScroll();
      
}function initAll(scope){var b=scope&&scope.querySelectorAll?scope:document;b.querySelectorAll('.wd-contact-options').forEach(init);if(scope&&scope.matches&&scope.matches('.wd-contact-options'))init(scope);}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initAll(document);},{once:true});else initAll(document);document.addEventListener('shopify:section:load',function(e){initAll(e.target);});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-exploded-views"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){

  if(!root || root.dataset.wdBound === 'true') return;
  root.dataset.wdBound = 'true';

  const cards = root.querySelectorAll('.wd-exploded__card');
  if(cards.length === 0) return;

  if(!('IntersectionObserver' in window)){
    cards.forEach(c => c.classList.add('is-in'));
  } else {
    root.classList.add('has-io');

    const io = new IntersectionObserver((entries, obs)=>{
      for (const en of entries){
        if(en.isIntersecting){
          en.target.classList.add('is-in');
          obs.unobserve(en.target);
        }
      }
    }, { rootMargin: '0px 0px -15% 0px', threshold: 0.01 });

    cards.forEach(c => io.observe(c));
  }

  const mq = window.matchMedia('(max-width: 699px)');
  const grid = root.querySelector('[data-wd-snap]');
  const dotsWrap = root.querySelector('[data-wd-exploded__dots]');
  if(!grid || !dotsWrap) return;

  const dots = Array.from(dotsWrap.querySelectorAll('.wd-exploded__dot'));
  if(dots.length <= 1) return;

  function setActive(idx){
    dots.forEach((d,i)=> d.classList.toggle('is-active', i === idx));
  }

  function getSlides(){
    const all = Array.from(grid.querySelectorAll('[data-wd-slide]'));
    return all.filter(el => el.offsetParent !== null);
  }

  let raf = 0;

  function update(){
    if(!mq.matches) return;

    const slides = getSlides();
    if(!slides.length) return;

    const max = Math.min(dots.length, slides.length);
    const x = grid.scrollLeft;

    let best = 0;
    let bestDist = Infinity;

    for(let i=0;i<max;i++){
      const dist = Math.abs(slides[i].offsetLeft - x);
      if(dist < bestDist){
        bestDist = dist;
        best = i;
      }
    }

    setActive(best);
  }

  function onScroll(){
    if(raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(update);
  }

  function onResize(){
    if(raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(update);
  }

  grid.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onResize, { passive: true });

  setTimeout(update, 60);

  }
  function initAll(scope){
    var base = scope && scope.querySelectorAll ? scope : document;
    base.querySelectorAll('.wd-exploded').forEach(init);
    if(scope && scope.matches && scope.matches('.wd-exploded')) init(scope);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ initAll(document); }, { once:true });
  else initAll(document);
  document.addEventListener('shopify:section:load', function(event){ initAll(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-featured-collection"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';

  function initFeatured(root){

          if(!root || root.dataset.wdfcBound==='1') return;
          root.dataset.wdfcBound='1';

          function isDesktop(){
            return window.matchMedia('(min-width: 1025px)').matches;
          }

          function getBool(v){
            return String(v) === 'true';
          }

          function init(){
            var enable = getBool(root.getAttribute('data-desktop-swipe'));
            if(!enable || !isDesktop()){
              root.classList.remove('is-desktop-swipe');
              return teardown();
            }

            var track = root.querySelector('[data-wdfc-track]');
            var controls = root.querySelector('[data-wdfc-controls]');
            var dotsWrap = root.querySelector('[data-wdfc-dots]');
            var btnPrev = root.querySelector('[data-wdfc-prev]');
            var btnNext = root.querySelector('[data-wdfc-next]');
            if(!track || !controls || !dotsWrap || !btnPrev || !btnNext) return;

            var gap = parseInt(root.getAttribute('data-desktop-gap') || '16', 10);
            var minCard = parseInt(root.getAttribute('data-desktop-min-card') || '260', 10);
            root.style.setProperty('--wd-gap', (gap / 16) + 'rem');

            var slides = Array.prototype.slice.call(track.children || []);
            var hasOverflow = track.scrollWidth > (track.clientWidth + 4);
            if(!hasOverflow){
              root.classList.remove('is-desktop-swipe');
              controls.classList.add('is-hidden');
              return teardown();
            }

            root.classList.add('is-desktop-swipe');
            controls.classList.remove('is-hidden');

            slides.forEach(function(s){
              s.style.width = 'clamp(220px, 24vw, 320px)';
              s.style.minWidth = minCard + 'px';
            });

            function clamp(n, a, b){ return Math.max(a, Math.min(b, n)); }

            function pageSize(){
              var w = track.clientWidth;
              var per = Math.max(1, Math.floor((w + gap) / (minCard + gap)));
              return per;
            }

            function maxIndex(){
              var per = pageSize();
              return Math.max(0, slides.length - per);
            }

            function nearestIndex(){
              var step = minCard + gap;
              var idx = Math.round(track.scrollLeft / step);
              return clamp(idx, 0, maxIndex());
            }

            function scrollToIndex(idx){
              var step = minCard + gap;
              track.scrollTo({ left: idx * step, behavior: 'smooth' });
            }

            function buildDots(){
              dotsWrap.innerHTML = '';
              var per = pageSize();
              var pages = Math.max(1, Math.ceil(slides.length / per));
              for(var i=0;i<pages;i++){
                var b = document.createElement('button');
                b.type = 'button';
                b.className = 'wdfc-dot';
                b.setAttribute('aria-label', (root.getAttribute('data-go-to-page') || 'Go to page') + ' ' + (i+1));
                (function(page){
                  b.addEventListener('click', function(){
                    var idx = page * per;
                    scrollToIndex(clamp(idx, 0, maxIndex()));
                  });
                })(i);
                dotsWrap.appendChild(b);
              }
            }

            function setActiveDot(){
              var per = pageSize();
              var idx = nearestIndex();
              var page = Math.floor(idx / per);
              var dots = dotsWrap.querySelectorAll('.wdfc-dot');
              for(var i=0;i<dots.length;i++){
                if(i === page){ dots[i].classList.add('is-active'); }
                else{ dots[i].classList.remove('is-active'); }
              }
            }

            function updateArrows(){
              var idx = nearestIndex();
              btnPrev.disabled = idx <= 0;
              btnNext.disabled = idx >= maxIndex();
            }

            function onPrev(){
              var per = pageSize();
              var idx = nearestIndex();
              scrollToIndex(clamp(idx - per, 0, maxIndex()));
            }

            function onNext(){
              var per = pageSize();
              var idx = nearestIndex();
              scrollToIndex(clamp(idx + per, 0, maxIndex()));
            }

            btnPrev.addEventListener('click', onPrev);
            btnNext.addEventListener('click', onNext);

            var isDown = false;
            var startX = 0;
            var startLeft = 0;

            track.addEventListener('mousedown', function(e){
              isDown = true;
              startX = e.pageX;
              startLeft = track.scrollLeft;
              track.style.scrollBehavior = 'auto';
            });

            window.addEventListener('mouseup', function(){
              if(!isDown) return;
              isDown = false;
              track.style.scrollBehavior = 'smooth';
              snapToNearest();
            });

            window.addEventListener('mousemove', function(e){
              if(!isDown) return;
              var dx = e.pageX - startX;
              track.scrollLeft = startLeft - dx;
            });

            track.addEventListener('mouseleave', function(){
              if(!isDown) return;
              isDown = false;
              track.style.scrollBehavior = 'smooth';
              snapToNearest();
            });

            track.addEventListener('wheel', function(e){
              if(!isDesktop()) return;
              if(Math.abs(e.deltaY) > Math.abs(e.deltaX)){
                track.scrollLeft += e.deltaY;
                e.preventDefault();
              }
            }, { passive: false });

            var t;
            track.addEventListener('scroll', function(){
              clearTimeout(t);
              t = setTimeout(function(){
                setActiveDot();
                updateArrows();
              }, 80);
            });

            function snapToNearest(){
              var idx = nearestIndex();
              scrollToIndex(idx);
              setActiveDot();
              updateArrows();
            }

            buildDots();
            setActiveDot();
            updateArrows();

            root._wdfc = {
              destroy: function(){
                btnPrev.removeEventListener('click', onPrev);
                btnNext.removeEventListener('click', onNext);
              }
            };
          }

          function teardown(){
            if(root._wdfc && root._wdfc.destroy) root._wdfc.destroy();
            root._wdfc = null;
          }

          init();

          var rTimer;
          window.addEventListener('resize', function(){
            clearTimeout(rTimer);
            rTimer = setTimeout(function(){
              teardown();
              init();
            }, 120);
          });
        
  }

  function initAll(scope){
    var context=scope&&scope.querySelectorAll?scope:document;
    context.querySelectorAll('[data-wdfc]').forEach(initFeatured);
    if(scope&&scope.matches&&scope.matches('[data-wdfc]')) initFeatured(scope);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){ initAll(document); },{once:true});
  }else{
    initAll(document);
  }
  document.addEventListener('shopify:section:load',function(event){ initAll(event.target); });
  document.addEventListener('shopify:section:unload',function(event){
    if(!event.target) return;
    event.target.querySelectorAll('[data-wdfc]').forEach(function(root){
      if(root._wdfc&&root._wdfc.destroy) root._wdfc.destroy();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-header"] && !Shopify.designMode) return;
  try {
    
(function(){
  var HEADER_SELECTOR = '[data-wd-header]';

  function initHeader(root){
    if(!root || root.getAttribute('data-wd-header-init') === 'true') return;

    root.setAttribute('data-wd-header-init','true');

    var html = document.documentElement;
    var cleanup = [];
    var observers = [];
    var timers = [];

    function listen(target,type,handler,options){
      if(!target || !target.addEventListener) return;

      target.addEventListener(type,handler,options);

      cleanup.push(function(){
        target.removeEventListener(type,handler,options);
      });
    }

    function rememberTimer(id,type){
      timers.push({
        id:id,
        type:type
      });

      return id;
    }

    function clearTimers(){
      timers.forEach(function(entry){
        if(entry.type === 'interval'){
          window.clearInterval(entry.id);
        }else{
          window.clearTimeout(entry.id);
        }
      });

      timers = [];
    }

    function initLanguage(){
      var form = root.querySelector('[data-wd-lang]');
      var select = form ? form.querySelector('select[name="locale_code"]') : null;

      if(!select) return;

      listen(select,'change',function(){
        var parentForm = select.closest('form');

        if(parentForm){
          parentForm.submit();
        }
      });
    }

    function initTopbarUsps(){
      var wrap = root.querySelector('[data-wd-usps]');
      var usps = wrap
        ? Array.prototype.slice.call(wrap.querySelectorAll('.wd-usp'))
        : [];

      if(!wrap || usps.length < 2) return;

      var mq = window.matchMedia
        ? window.matchMedia('(max-width: 989px)')
        : null;

      var reduce = window.matchMedia
        ? window.matchMedia('(prefers-reduced-motion: reduce)')
        : { matches:false };

      var idx = 0;
      var timer = null;

      function clearAnim(el){
        el.classList.remove('wk-in','wk-out','is-active');
      }

      function show(i,animate){
        for(var k = 0;k < usps.length;k++){
          if(k !== i){
            clearAnim(usps[k]);
          }
        }

        var el = usps[i];

        if(!el) return;

        el.classList.add('is-active');

        if(animate && !reduce.matches){
          el.classList.add('wk-in');
        }
      }

      function stop(){
        if(timer){
          window.clearInterval(timer);
          timer = null;
        }
      }

      function start(){
        stop();

        for(var i = 0;i < usps.length;i++){
          clearAnim(usps[i]);
        }

        if(!mq || !mq.matches || document.hidden) return;

        idx = 0;
        show(idx,false);

        timer = window.setInterval(function(){
          var current = usps[idx];

          if(current && !reduce.matches){
            current.classList.remove('wk-in');
            current.classList.add('wk-out');
          }

          if(current){
            current.classList.remove('is-active');
          }

          idx = (idx + 1) % usps.length;
          show(idx,true);
        },5000);
      }

      start();

      if(mq){
        if(mq.addEventListener){
          mq.addEventListener('change',start);

          cleanup.push(function(){
            mq.removeEventListener('change',start);
          });
        }else if(mq.addListener){
          mq.addListener(start);

          cleanup.push(function(){
            mq.removeListener(start);
          });
        }
      }

      listen(document,'visibilitychange',function(){
        if(document.hidden){
          stop();
        }else{
          start();
        }
      });

      cleanup.push(stop);
    }

    function initAnnouncement(){
      var wrap = root.querySelector('[data-wd-annbar-usp]');

      if(!wrap) return;

      var textEl = wrap.querySelector('[data-wd-annbar-text]');

      if(!textEl) return;

      if(String(root.getAttribute('data-wd-annbar-rotate')) !== 'true') return;

      var interval = Number(
        root.getAttribute('data-wd-annbar-interval') || '3.5'
      ) || 3.5;

      interval = Math.max(2,Math.min(12,interval));

      var items = [
        wrap.getAttribute('data-wd-annbar-item-1') || '',
        wrap.getAttribute('data-wd-annbar-item-2') || '',
        wrap.getAttribute('data-wd-annbar-item-3') || ''
      ].filter(Boolean);

      if(items.length <= 1) return;

      if(
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ){
        return;
      }

      var idx = 0;

      try{
        var saved = sessionStorage.getItem('wd_annbar');

        if(saved){
          idx = Math.max(
            0,
            Math.min(
              items.length - 1,
              parseInt(saved,10) || 0
            )
          );
        }
      }catch(e){}

      function setText(i){
        idx = i % items.length;
        textEl.textContent = items[idx];

        try{
          sessionStorage.setItem('wd_annbar',String(idx));
        }catch(e){}
      }

      setText(idx);

      var timer = window.setInterval(function(){
        if(!document.hidden){
          setText(idx + 1);
        }
      },Math.round(interval * 1000));

      cleanup.push(function(){
        window.clearInterval(timer);
      });
    }

    function initSearchMenu(){
      var form = root.querySelector('[data-wd-search-form]');
      var input = form
        ? form.querySelector('[data-wd-search-input]')
        : null;

      var panel = form
        ? form.querySelector('[data-wd-search-panel]')
        : null;

      if(!form || !input || !panel) return;

      function setOpen(open){
        form.classList.toggle('is-menu-open',!!open);

        input.setAttribute(
          'aria-expanded',
          open ? 'true' : 'false'
        );

        panel.setAttribute(
          'aria-hidden',
          open ? 'false' : 'true'
        );
      }

      listen(input,'focus',function(){
        setOpen(true);
      });

      listen(input,'click',function(){
        setOpen(true);
      });

      listen(form,'keydown',function(event){
        if(event.key === 'Escape'){
          setOpen(false);
          input.focus();
        }
      });

      listen(document,'pointerdown',function(event){
        if(!form.contains(event.target)){
          setOpen(false);
        }
      },true);

      listen(form,'submit',function(){
        setOpen(false);
      });
    }

    function syncPriceControls(){
      var hidden =
        html.classList &&
        html.classList.contains('wd-prices-hidden');

      var cartBtn = root.querySelector('[data-wd-cart-btn]');

      if(cartBtn){
        if(hidden){
          cartBtn.setAttribute('aria-disabled','true');
          cartBtn.setAttribute('tabindex','-1');
        }else{
          cartBtn.removeAttribute('aria-disabled');
          cartBtn.removeAttribute('tabindex');
        }
      }

      var openBtn = root.querySelector('[data-wd-prices-show]');

      if(openBtn){
        openBtn.setAttribute(
          'aria-expanded',
          hidden ? 'false' : 'true'
        );
      }
    }

    function initPriceControls(){
      var cartBtn = root.querySelector('[data-wd-cart-btn]');

      if(cartBtn){
        listen(cartBtn,'click',function(event){
          if(
            html.classList &&
            html.classList.contains('wd-prices-hidden')
          ){
            event.preventDefault();
            event.stopPropagation();
          }
        },true);
      }

      syncPriceControls();

      if(window.MutationObserver){
        var observer = new MutationObserver(syncPriceControls);

        observer.observe(html,{
          attributes:true,
          attributeFilter:['class']
        });

        observers.push(observer);
      }
    }

    initLanguage();
    initTopbarUsps();
    initAnnouncement();
    initSearchMenu();
    initPriceControls();

    root.__wdHeaderCleanup = function(){
      clearTimers();

      cleanup.forEach(function(fn){
        try{
          fn();
        }catch(e){}
      });

      observers.forEach(function(observer){
        try{
          observer.disconnect();
        }catch(e){}
      });

      root.removeAttribute('data-wd-header-init');
      delete root.__wdHeaderCleanup;
    };
  }

  function initWithin(scope){
    var base = scope || document;

    if(
      base.matches &&
      base.matches(HEADER_SELECTOR)
    ){
      initHeader(base);
    }

    var roots = base.querySelectorAll
      ? base.querySelectorAll(HEADER_SELECTOR)
      : [];

    for(var i = 0;i < roots.length;i++){
      initHeader(roots[i]);
    }
  }

  initWithin(document);

  document.addEventListener(
    'shopify:section:load',
    function(event){
      initWithin(event.target);
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    function(event){
      var root =
        event.target &&
        event.target.querySelector
          ? event.target.querySelector(HEADER_SELECTOR)
          : null;

      if(
        root &&
        typeof root.__wdHeaderCleanup === 'function'
      ){
        root.__wdHeaderCleanup();
      }
    }
  );
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-help-center"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';

      

      function toArr(nl){
        return Array.prototype.slice.call(nl || []);
      }

      function cleanKey(v){
        v = String(v || '').trim().toLowerCase();
        v = v.replace(/\s+/g, '-');
        v = v.replace(/[\/\\]/g, '-');
        v = v.replace(/&/g, 'and');
        v = v.replace(/["']/g, '');
        v = v.replace(/-+/g, '-');
        return v;
      }

      function debounce(fn, wait){
        var t = null;
        return function(){
          var ctx = this;
          var args = arguments;
          clearTimeout(t);
          t = setTimeout(function(){
            fn.apply(ctx, args);
          }, wait);
        };
      }

      function init(root){
        if(!root) return;
        if(root.dataset.wdhBound === 'true') return;
        root.dataset.wdhBound = 'true';

        var navBtns = toArr(root.querySelectorAll('[data-cat-btn]'));
        var catSelect = root.querySelector('[data-cat-select]');
        var searchLeft = root.querySelector('.wdh-search-left');
        var searchMain = root.querySelector('.wdh-search-main');
        var catHeads = toArr(root.querySelectorAll('[data-cat-head]'));
        var items = toArr(root.querySelectorAll('[data-faq]'));
        var emptyEl = root.querySelector('[data-empty]');
        var resultsEl = root.querySelector('[data-results-count]');

        items.forEach(function(it){
          var txt = it.textContent || '';
          it.__wdhText = String(txt).toLowerCase();
        });

        function getSearch(){
          var v1 = searchMain ? searchMain.value : '';
          var v2 = searchLeft ? searchLeft.value : '';
          return String(v1 || v2 || '').trim().toLowerCase();
        }

        function syncSearch(val){
          val = String(val || '');
          if(searchLeft && searchLeft.value !== val) searchLeft.value = val;
          if(searchMain && searchMain.value !== val) searchMain.value = val;
        }

        function activeCat(){
          if(catSelect && catSelect.value) return cleanKey(catSelect.value);
          var activeBtn = root.querySelector('[data-cat-btn][aria-pressed="true"]');
          if(activeBtn) return cleanKey(activeBtn.getAttribute('data-cat') || 'all');
          return 'all';
        }

        function setHeader(catKey){
          catKey = cleanKey(catKey || 'all');
          var matched = false;

          catHeads.forEach(function(head){
            var key = cleanKey(head.getAttribute('data-cat-head') || '');
            var show = key === catKey;
            head.hidden = !show;
            if(show) matched = true;
          });

          if(!matched){
            catHeads.forEach(function(head){
              var key = cleanKey(head.getAttribute('data-cat-head') || '');
              head.hidden = key !== 'fallback';
            });
          }
        }

        function closeAll(){
          items.forEach(function(it){
            it.setAttribute('data-open', 'false');

            var btn = it.querySelector('[data-q]');
            var panel = it.querySelector('[data-a]');

            if(btn) btn.setAttribute('aria-expanded', 'false');
            if(panel) panel.style.height = '0px';
          });
        }

        function openItem(it){
          var btn = it.querySelector('[data-q]');
          var panel = it.querySelector('[data-a]');
          if(!btn || !panel) return;

          it.setAttribute('data-open', 'true');
          btn.setAttribute('aria-expanded', 'true');

          panel.style.height = '0px';
          var target = panel.scrollHeight;

          requestAnimationFrame(function(){
            panel.style.height = target + 'px';
          });
        }

        function refreshOpenHeight(){
          items.forEach(function(it){
            if(it.getAttribute('data-open') !== 'true') return;
            if(it.style.display === 'none') return;

            var panel = it.querySelector('[data-a]');
            if(panel){
              panel.style.height = panel.scrollHeight + 'px';
            }
          });
        }

        function filterAll(){
          var catKey = activeCat();
          var q = getSearch();
          var visible = 0;

          items.forEach(function(it){
            var cat = cleanKey(it.getAttribute('data-cat') || '');
            var text = it.__wdhText || '';

            var catOk = catKey === 'all' ? true : cat === catKey;
            var qOk = q ? text.indexOf(q) > -1 : true;
            var show = catOk && qOk;

            it.style.display = show ? '' : 'none';

            if(!show){
              it.setAttribute('data-open', 'false');
              var btn = it.querySelector('[data-q]');
              var panel = it.querySelector('[data-a]');
              if(btn) btn.setAttribute('aria-expanded', 'false');
              if(panel) panel.style.height = '0px';
            } else {
              visible += 1;
            }
          });

          if(resultsEl) {
            resultsEl.textContent = String(visible);
            var resultLabel=root.querySelector('[data-results-label]');
            if(resultLabel){
              var locale=(document.documentElement.lang||'nl').slice(0,2);
              resultLabel.textContent=locale==='en'?(visible===1?'result':'results'):locale==='de'?(visible===1?'Ergebnis':'Ergebnisse'):(visible===1?'resultaat':'resultaten');
            }
          }
          if(emptyEl) emptyEl.style.display = visible === 0 && items.length > 0 ? 'block' : 'none';

          refreshOpenHeight();
        }

        function setActive(catKey){
          catKey = cleanKey(catKey || 'all');
          if(!catKey) catKey = 'all';

          navBtns.forEach(function(btn){
            var isActive = cleanKey(btn.getAttribute('data-cat') || 'all') === catKey;
            btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });

          if(catSelect && cleanKey(catSelect.value) !== catKey){
            catSelect.value = catKey;
          }

          setHeader(catKey);
          closeAll();
          filterAll();
        }

        function onFilterKeydown(e){
          var k = e.key || '';
          if(k !== 'ArrowDown' && k !== 'ArrowUp' && k !== 'ArrowLeft' && k !== 'ArrowRight' && k !== 'Home' && k !== 'End') return;

          if(!navBtns.length) return;

          var idx = 0;
          for(var i = 0; i < navBtns.length; i++){
            if(navBtns[i].getAttribute('aria-pressed') === 'true'){
              idx = i;
              break;
            }
          }

          var next = idx;
          if(k === 'Home') next = 0;
          if(k === 'End') next = navBtns.length - 1;
          if(k === 'ArrowDown' || k === 'ArrowRight') next = Math.min(navBtns.length - 1, idx + 1);
          if(k === 'ArrowUp' || k === 'ArrowLeft') next = Math.max(0, idx - 1);

          e.preventDefault();

          var target = navBtns[next];
          if(target){
            target.focus();
            setActive(target.getAttribute('data-cat') || 'all');
          }
        }

        root.addEventListener('click', function(e){
          var catBtn = e.target.closest('[data-cat-btn]');
          if(catBtn){
            setActive(catBtn.getAttribute('data-cat') || 'all');
            return;
          }

          var qBtn = e.target.closest('[data-q]');
          if(!qBtn) return;

          var item = qBtn.closest('[data-faq]');
          if(!item) return;
          if(item.style.display === 'none') return;

          var isOpen = item.getAttribute('data-open') === 'true';

          if(isOpen){
            item.setAttribute('data-open', 'false');
            qBtn.setAttribute('aria-expanded', 'false');

            var panelClose = item.querySelector('[data-a]');
            if(panelClose) panelClose.style.height = '0px';
            return;
          }

          closeAll();
          openItem(item);
        });

        navBtns.forEach(function(btn){
          btn.addEventListener('keydown', onFilterKeydown);
        });

        if(catSelect){
          catSelect.addEventListener('change', function(){
            setActive(catSelect.value || 'all');
          });
        }

        var onSearch = debounce(function(el){
          syncSearch(el.value || '');
          closeAll();
          filterAll();
        }, 80);

        if(searchLeft){
          searchLeft.addEventListener('input', function(){
            onSearch(searchLeft);
          });
        }

        if(searchMain){
          searchMain.addEventListener('input', function(){
            onSearch(searchMain);
          });
        }

        window.addEventListener('resize', debounce(function(){
          refreshOpenHeight();
        }, 80));

        if(window.Shopify && Shopify.designMode && window.MutationObserver){
          try{
            var obs = new MutationObserver(function(){
              refreshOpenHeight();
            });
            obs.observe(root, { childList: true, subtree: true });
          } catch(e){}
        }

        setActive('all');
      }
    

  function initAll(scope, force){
    var context=scope&&scope.querySelectorAll?scope:document;
    var roots=Array.prototype.slice.call(context.querySelectorAll('[data-wdh]'));
    if(scope&&scope.matches&&scope.matches('[data-wdh]')) roots.unshift(scope);
    roots.forEach(function(root){
      if(force) root.dataset.wdhBound='false';
      init(root);
    });
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){initAll(document,false);},{once:true}); else initAll(document,false);
  document.addEventListener('shopify:section:load',function(e){initAll(e.target,true);});
  document.addEventListener('shopify:section:select',function(e){initAll(e.target,true);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';

  function initHero(root){

        var sectionId = root.getAttribute('data-section-id') || '';
        if(!sectionId || !root.querySelector('[data-wd-usp]')) return;

        var registryKey = '__wdHero_' + sectionId;

        if(window[registryKey] && typeof window[registryKey].destroy === 'function'){
          window[registryKey].destroy();
        }

        var mql = null;
        var reduceMql = null;
        var mode = (root.getAttribute('data-wd-usp-mode-m') || 'grid').toLowerCase();
        var autoplay = root.getAttribute('data-wd-usp-autoplay') === 'true';
        var interval = parseInt(root.getAttribute('data-wd-usp-interval') || '3600', 10);
        var dotsOn = root.getAttribute('data-wd-usp-dots') === 'true';

        try{
          mql = window.matchMedia('(max-width: 759px)');
          reduceMql = window.matchMedia('(prefers-reduced-motion: reduce)');
        }catch(e){}

        var usp = root.querySelector('[data-wd-usp]');
        var viewport = usp ? usp.querySelector('[data-wd-usp-viewport]') : null;
        var track = usp ? usp.querySelector('[data-wd-usp-track]') : null;
        var dotsWrap = usp ? usp.querySelector('[data-wd-usp-dots]') : null;
        var status = usp ? usp.querySelector('[data-wd-usp-status]') : null;
        var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-wd-usp-slide]')) : [];
        var dots = dotsWrap ? Array.prototype.slice.call(dotsWrap.querySelectorAll('[data-wd-usp-dot]')) : [];

        var index = 0;
        var timer = null;
        var dragging = false;
        var hovering = false;
        var focusInside = false;
        var startX = 0;
        var lastX = 0;
        var destroyed = false;

        if(!usp || !viewport || !track || slides.length <= 1){
          return;
        }

        function isMobile(){
          return !!(mql && mql.matches);
        }

        function prefersReducedMotion(){
          return !!(reduceMql && reduceMql.matches);
        }

        function clamp(number, min, max){
          return Math.max(min, Math.min(max, number));
        }

        function setDot(active){
          dots.forEach(function(dot, dotIndex){
            var isActive = dotIndex === active;
            dot.setAttribute('aria-current', isActive ? 'true' : 'false');
            dot.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });
        }

        function announce(active){
          if(!status || !slides[active]) return;

          status.textContent = slides[active].getAttribute('data-wd-slide-status') || '';
        }

        function goTo(nextIndex, noAnim, shouldAnnounce){
          index = clamp(nextIndex, 0, slides.length - 1);

          var x = -index * 100;
          var noMotion = prefersReducedMotion() || noAnim;

          track.style.transition = noMotion ? 'none' : 'transform .45s ease';
          track.style.transform = 'translateX(' + x + '%)';

          setDot(index);

          if(shouldAnnounce){
            announce(index);
          }

          if(noAnim && !prefersReducedMotion()){
            window.requestAnimationFrame(function(){
              if(destroyed) return;

              track.style.transition = 'transform .45s ease';
            });
          }
        }

        function stop(){
          if(timer){
            window.clearInterval(timer);
            timer = null;
          }
        }

        function canAutoplay(){
          return !destroyed &&
            !prefersReducedMotion() &&
            autoplay &&
            mode === 'slider' &&
            isMobile() &&
            !dragging &&
            !hovering &&
            !focusInside &&
            !document.hidden;
        }

        function start(){
          stop();

          if(!canAutoplay()) return;

          timer = window.setInterval(function(){
            if(!canAutoplay()){
              stop();
              return;
            }

            var next = index + 1;

            if(next >= slides.length){
              next = 0;
            }

            goTo(next, false, false);
          }, Math.max(2200, interval || 3600));
        }

        function handleDotClick(event){
          var dot = event.target && event.target.closest ? event.target.closest('[data-wd-usp-dot]') : null;

          if(!dot || !dotsWrap || !dotsWrap.contains(dot)) return;

          var dotIndex = parseInt(dot.getAttribute('data-wd-usp-dot') || '0', 10);

          if(isNaN(dotIndex)){
            dotIndex = 0;
          }

          stop();
          goTo(dotIndex, false, true);
          start();
        }

        function handlePointerDown(event){
          if(mode !== 'slider' || !isMobile() || (event.pointerType === 'mouse' && event.button !== 0)) return;

          dragging = true;
          stop();
          startX = event.clientX;
          lastX = startX;

          try{
            viewport.setPointerCapture(event.pointerId);
          }catch(e){}
        }

        function handlePointerMove(event){
          if(!dragging) return;

          lastX = event.clientX;
        }

        function finishPointerGesture(announceChange){
          if(!dragging) return;

          dragging = false;

          var delta = lastX - startX;

          if(Math.abs(delta) > 40){
            goTo(delta < 0 ? index + 1 : index - 1, false, announceChange);
          }else{
            goTo(index, false, false);
          }

          start();
        }

        function handlePointerUp(){
          finishPointerGesture(true);
        }

        function handlePointerCancel(){
          dragging = false;
          goTo(index, true, false);
          start();
        }

        function handleKeydown(event){
          if(mode !== 'slider' || !isMobile()) return;

          if(event.key === 'ArrowLeft'){
            event.preventDefault();
            stop();
            goTo(index - 1, false, true);
            start();
          }else if(event.key === 'ArrowRight'){
            event.preventDefault();
            stop();
            goTo(index + 1, false, true);
            start();
          }else if(event.key === 'Home'){
            event.preventDefault();
            stop();
            goTo(0, false, true);
            start();
          }else if(event.key === 'End'){
            event.preventDefault();
            stop();
            goTo(slides.length - 1, false, true);
            start();
          }
        }

        function handlePointerEnter(){
          hovering = true;
          stop();
        }

        function handlePointerLeave(){
          hovering = false;
          start();
        }

        function handleFocusIn(){
          focusInside = true;
          stop();
        }

        function handleFocusOut(event){
          if(usp.contains(event.relatedTarget)) return;

          focusInside = false;
          start();
        }

        function handleVisibilityChange(){
          if(document.hidden){
            stop();
          }else{
            start();
          }
        }

        function handleMediaChange(){
          if(mode === 'slider' && isMobile()){
            goTo(index, true, false);
            start();
          }else{
            stop();
            goTo(0, true, false);
          }
        }

        function handleMotionChange(){
          if(prefersReducedMotion()){
            stop();
            goTo(index, true, false);
          }else{
            start();
          }
        }

        function handleBlockSelect(event){
          if(!event.detail || event.detail.sectionId !== sectionId || !event.detail.blockId) return;

          for(var i = 0; i < slides.length; i++){
            if(slides[i].getAttribute('data-wd-block-id') === event.detail.blockId){
              stop();
              goTo(i, false, true);
              start();
              return;
            }
          }
        }

        function handleSectionUnload(event){
          if(!event.detail || event.detail.sectionId !== sectionId) return;

          destroy();
        }

        function addMediaListener(query, handler){
          if(!query) return;

          if(query.addEventListener){
            query.addEventListener('change', handler);
          }else if(query.addListener){
            query.addListener(handler);
          }
        }

        function removeMediaListener(query, handler){
          if(!query) return;

          if(query.removeEventListener){
            query.removeEventListener('change', handler);
          }else if(query.removeListener){
            query.removeListener(handler);
          }
        }

        function destroy(){
          if(destroyed) return;

          destroyed = true;
          stop();

          if(dotsWrap){
            dotsWrap.removeEventListener('click', handleDotClick);
          }

          viewport.removeEventListener('pointerdown', handlePointerDown);
          viewport.removeEventListener('pointermove', handlePointerMove);
          viewport.removeEventListener('pointerup', handlePointerUp);
          viewport.removeEventListener('pointercancel', handlePointerCancel);
          viewport.removeEventListener('keydown', handleKeydown);
          usp.removeEventListener('pointerenter', handlePointerEnter);
          usp.removeEventListener('pointerleave', handlePointerLeave);
          usp.removeEventListener('focusin', handleFocusIn);
          usp.removeEventListener('focusout', handleFocusOut);
          document.removeEventListener('visibilitychange', handleVisibilityChange);
          document.removeEventListener('shopify:block:select', handleBlockSelect);
          document.removeEventListener('shopify:section:unload', handleSectionUnload);
          removeMediaListener(mql, handleMediaChange);
          removeMediaListener(reduceMql, handleMotionChange);

          if(window[registryKey]){
            window[registryKey] = null;
          }
        }

        if(dotsWrap){
          dotsWrap.style.display = dotsOn ? '' : 'none';
          dotsWrap.addEventListener('click', handleDotClick);
        }

        viewport.addEventListener('pointerdown', handlePointerDown);
        viewport.addEventListener('pointermove', handlePointerMove);
        viewport.addEventListener('pointerup', handlePointerUp);
        viewport.addEventListener('pointercancel', handlePointerCancel);
        viewport.addEventListener('keydown', handleKeydown);
        usp.addEventListener('pointerenter', handlePointerEnter);
        usp.addEventListener('pointerleave', handlePointerLeave);
        usp.addEventListener('focusin', handleFocusIn);
        usp.addEventListener('focusout', handleFocusOut);
        document.addEventListener('visibilitychange', handleVisibilityChange);
        document.addEventListener('shopify:block:select', handleBlockSelect);
        document.addEventListener('shopify:section:unload', handleSectionUnload);
        addMediaListener(mql, handleMediaChange);
        addMediaListener(reduceMql, handleMotionChange);

        window[registryKey] = {
          destroy: destroy
        };

        goTo(0, true, false);
        start();
      
  }

  function initAll(scope){
    var context=scope&&scope.querySelectorAll?scope:document;
    context.querySelectorAll('[data-wd-hero]').forEach(initHero);
    if(scope&&scope.matches&&scope.matches('[data-wd-hero]')) initHero(scope);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){ initAll(document); },{once:true});
  }else{
    initAll(document);
  }
  document.addEventListener('shopify:section:load',function(event){ initAll(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-home-about"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';
  function init(root){

      if(!root || root.dataset.homeAboutBound==='1') return;
      root.dataset.homeAboutBound='1';

      var track = root.querySelector('[data-usp-track]');
      var dotsWrap = root.querySelector('[data-usp-dots]');
      if(!track || !dotsWrap) return;

      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-usp-slide]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-usp-dot]'));
      if(slides.length < 2 || dots.length < 2) return;

      var mql = window.matchMedia('(max-width: 900px)');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

      function setActive(index){
        dots.forEach(function(btn, i){
          btn.setAttribute('aria-current', i === index ? 'true' : 'false');
        });
      }

      function getClosestIndex(){
        var trackRect = track.getBoundingClientRect();
        var center = trackRect.left + (trackRect.width / 2);
        var best = 0;
        var bestDist = Infinity;

        for(var i=0;i<slides.length;i++){
          var r = slides[i].getBoundingClientRect();
          var c = r.left + (r.width / 2);
          var d = Math.abs(c - center);
          if(d < bestDist){
            bestDist = d;
            best = i;
          }
        }
        return best;
      }

      var ticking = false;
      function onScroll(){
        if(!mql.matches) return;
        if(ticking) return;
        ticking = true;
        window.requestAnimationFrame(function(){
          ticking = false;
          setActive(getClosestIndex());
        });
      }

      function scrollToIndex(index){
        if(index < 0) index = 0;
        if(index > slides.length - 1) index = slides.length - 1;
        var behavior = (reduce && reduce.matches) ? 'auto' : 'smooth';
        slides[index].scrollIntoView({ behavior: behavior, block: 'nearest', inline: 'center' });
        setActive(index);
      }

      dots.forEach(function(btn){
        btn.addEventListener('click', function(){
          if(!mql.matches) return;
          var idx = parseInt(btn.getAttribute('data-usp-dot') || '0', 10);
          scrollToIndex(idx);
        });
      });

      track.addEventListener('scroll', onScroll, { passive: true });

      function init(){
        if(mql.matches){
          setActive(getClosestIndex());
        } else {
          setActive(0);
        }
      }

      if(mql.addEventListener){
        mql.addEventListener('change', init);
      } else if(mql.addListener){
        mql.addListener(init);
      }

      init();
    
  }
  function initAll(scope){var c=scope&&scope.querySelectorAll?scope:document;c.querySelectorAll('[data-wd-homeabout]').forEach(init);if(scope&&scope.matches&&scope.matches('[data-wd-homeabout]'))init(scope);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initAll(document);},{once:true});else initAll(document);
  document.addEventListener('shopify:section:load',function(e){initAll(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-list-collections"] && !Shopify.designMode) return;
  try {
    

(function(){
  'use strict';

  function initCollectionList(section){
    if(!section){
      return;
    }

    if(section.dataset.wdCollectionsBound === '1'){
      return;
    }

    section.dataset.wdCollectionsBound = '1';

    var input = section.querySelector(
      '[data-wd-collection-search]'
    );

    var cards = Array.prototype.slice.call(
      section.querySelectorAll(
        '[data-wd-collection-card]'
      )
    );

    var noResults = section.querySelector(
      '[data-wd-collection-no-results]'
    );

    var reset = section.querySelector(
      '[data-wd-collection-reset]'
    );

    var visibleCount = section.querySelector(
      '[data-wd-collection-visible-count]'
    );

    var countLabel = section.querySelector(
      '[data-wd-collection-count-label]'
    );

    if(!input || !cards.length){
      return;
    }

    function normalize(value){
      return String(value || '')
        .toLocaleLowerCase(section.getAttribute('data-normalize-locale') || 'nl-NL')
        .trim();
    }

    function update(){
      var query = normalize(input.value);
      var matches = 0;

      cards.forEach(function(card){
        var value = normalize(
          card.getAttribute('data-search-value')
        );

        var isMatch =
          query === '' ||
          value.indexOf(query) !== -1;

        card.hidden = !isMatch;

        if(isMatch){
          matches += 1;
        }
      });

      if(noResults){
        noResults.hidden = matches !== 0;
      }

      if(visibleCount){
        visibleCount.textContent = String(matches);
      }

      if(countLabel){
        countLabel.textContent =
          matches === 1
            ? (section.getAttribute('data-count-singular') || 'collection')
            : (section.getAttribute('data-count-plural') || 'collections');
      }
    }

    input.addEventListener(
      'input',
      update
    );

    if(reset){
      reset.addEventListener(
        'click',
        function(){
          input.value = '';
          update();
          input.focus();
        }
      );
    }
  }

  function initAll(scope){
    var base = scope || document;

    if(
      base.matches &&
      base.matches('[data-wd-collections]')
    ){
      initCollectionList(base);
    }

    if(!base.querySelectorAll){
      return;
    }

    var roots = base.querySelectorAll(
      '[data-wd-collections]'
    );

    Array.prototype.forEach.call(
      roots,
      function(root){
        initCollectionList(root);
      }
    );
  }

  if(document.readyState === 'loading'){
    document.addEventListener(
      'DOMContentLoaded',
      function(){
        initAll(document);
      }
    );
  }else{
    initAll(document);
  }

  document.addEventListener(
    'shopify:section:load',
    function(event){
      initAll(event.target);
    }
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-main-article"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';
  function init(root){

      if(!root || root.dataset.blogArticleBound==='1') return;
      root.dataset.blogArticleBound='1';
      var sectionId = root.getAttribute('data-section-id') || '';

      function prefersReducedMotion(){
        try{
          return window.matchMedia &&
            window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        }catch(e){
          return false;
        }
      }

      function safeText(el){
        if(!el){
          return '';
        }

        return (el.textContent || '')
          .replace(/\s+/g, ' ')
          .trim();
      }

      function setButtonLabel(btn, text){
        if(!btn){
          return;
        }

        var label = btn.querySelector('.wk-sbtn-label');

        if(label){
          label.textContent = text;
        }
      }

      var shareBtn = document.getElementById(
        'wk-native-share-' + sectionId
      );

      if(shareBtn){
        if(navigator.share){
          shareBtn.addEventListener('click', function(){
            try{
              navigator.share({
                title: (root.getAttribute('data-share-title') || ''),
                url: (root.getAttribute('data-share-url') || window.location.href)
              }).catch(function(){});
            }catch(e){}
          });
        }else{
          shareBtn.style.display = 'none';
        }
      }

      var copyBtn = document.getElementById(
        'wk-copy-' + sectionId
      );

      if(copyBtn){
        copyBtn.addEventListener('click', function(){
          var original =
            (root.getAttribute('data-copy-label') || 'Kopieer');

          var url =
            copyBtn.getAttribute('data-copy-url') ||
            (root.getAttribute('data-share-url') || window.location.href);

          var doneText =
            (root.getAttribute('data-copied-label') || 'Gekopieerd!');

          function resetLater(){
            window.setTimeout(function(){
              setButtonLabel(copyBtn, original);
            }, 1200);
          }

          function onDone(){
            setButtonLabel(copyBtn, doneText);
            resetLater();
          }

          try{
            if(
              navigator.clipboard &&
              window.isSecureContext
            ){
              navigator.clipboard
                .writeText(url)
                .then(function(){
                  onDone();
                })
                .catch(function(){});

              return;
            }
          }catch(e){}

          try{
            var ta = document.createElement('textarea');

            ta.value = url;
            ta.setAttribute('readonly', '');
            ta.style.position = 'fixed';
            ta.style.left = '-9999px';

            document.body.appendChild(ta);

            ta.select();
            ta.setSelectionRange(0, ta.value.length);

            var ok = document.execCommand('copy');

            document.body.removeChild(ta);

            if(ok){
              onDone();
            }
          }catch(e){}
        });
      }

      if(root.getAttribute('data-show-progress') === 'true'){
        (function(){
          var bar = document.getElementById(
            'wk-progress-' + sectionId
          );

          var el = document.getElementById(
            'wk-article-content-' + sectionId
          );

          if(!bar || !el){
            return;
          }

          function getRange(){
            var rect = el.getBoundingClientRect();
            var top = rect.top + window.scrollY;
            var bottom = rect.bottom + window.scrollY;

            var total = Math.max(
              1,
              (bottom - top) - window.innerHeight
            );

            return {
              top: top,
              total: total
            };
          }

          var r = getRange();

          function onScroll(){
            var y = Math.max(
              0,
              Math.min(
                window.scrollY - r.top,
                r.total
              )
            );

            bar.style.width =
              ((y / r.total) * 100) + '%';
          }

          function onResize(){
            r = getRange();
            onScroll();
          }

          window.addEventListener(
            'scroll',
            onScroll,
            {
              passive: true
            }
          );

          window.addEventListener(
            'resize',
            onResize
          );

          onResize();
        })();
      }

      if(root.getAttribute('data-show-toc') === 'true'){
        (function(){
          var container = document.getElementById(
            'wk-article-content-' + sectionId
          );

          var toc = document.getElementById(
            'wk-toc-' + sectionId
          );

          if(!container || !toc){
            return;
          }

          var heads = container.querySelectorAll(
            'h2, h3'
          );

          if(!heads || !heads.length){
            var small = document.createElement('small');

            small.className = 'wk-toc-empty';
            small.textContent =
              (root.getAttribute('data-toc-empty') || 'No table of contents');

            toc.appendChild(small);

            return;
          }

          var ul = document.createElement('ul');

          for(var i = 0; i < heads.length; i++){
            var h = heads[i];

            if(!h.id){
              h.id =
                'wk-sect-' + sectionId + '-' + i;
            }

            var li = document.createElement('li');
            var a = document.createElement('a');

            a.href = '#' + h.id;

            if(h.tagName === 'H3'){
              a.className = 'is-h3';
            }

            a.textContent = safeText(h);

            li.appendChild(a);
            ul.appendChild(li);
          }

          toc.appendChild(ul);

          var links = toc.querySelectorAll('a');

          var offset =
            parseInt(root.getAttribute('data-scroll-offset') || '92',10);

          for(var j = 0; j < links.length; j++){
            links[j].addEventListener(
              'click',
              function(e){
                e.preventDefault();

                var id =
                  (this.getAttribute('href') || '')
                    .slice(1);

                var target =
                  document.getElementById(id);

                if(!target){
                  return;
                }

                var y =
                  target.getBoundingClientRect().top +
                  window.scrollY -
                  offset;

                var behavior =
                  prefersReducedMotion()
                    ? 'auto'
                    : 'smooth';

                try{
                  window.scrollTo({
                    top: y,
                    behavior: behavior
                  });
                }catch(err){
                  window.scrollTo(0, y);
                }
              }
            );
          }

          if(!('IntersectionObserver' in window)){
            return;
          }

          var current = null;

          var io = new IntersectionObserver(
            function(entries){
              for(
                var k = 0;
                k < entries.length;
                k++
              ){
                var entry = entries[k];

                if(entry.isIntersecting){
                  var id2 =
                    '#' + entry.target.id;

                  var next =
                    toc.querySelector(
                      'a[href="' + id2 + '"]'
                    );

                  if(
                    next &&
                    next !== current
                  ){
                    if(current){
                      current.classList.remove(
                        'active'
                      );
                    }

                    next.classList.add(
                      'active'
                    );

                    current = next;
                  }
                }
              }
            },
            {
              rootMargin: '-45% 0% -50% 0%',
              threshold: [0, 1]
            }
          );

          for(
            var m = 0;
            m < heads.length;
            m++
          ){
            io.observe(heads[m]);
          }
        })();
      }
    
  }
  function initAll(scope){var c=scope&&scope.querySelectorAll?scope:document;c.querySelectorAll('[data-wd-main-article]').forEach(init);if(scope&&scope.matches&&scope.matches('[data-wd-main-article]'))init(scope);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initAll(document);},{once:true});else initAll(document);
  document.addEventListener('shopify:section:load',function(e){initAll(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-metrics-bar"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){

if(!root || root.dataset.wdBound === 'true') return;
root.dataset.wdBound = 'true';
const sec = root;

const vals  = sec.querySelectorAll('[data-countup]');
const items = sec.querySelectorAll('.wd-metrics__item');
const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const canIO = 'IntersectionObserver' in window;

if (canIO) {
  const ioItems = new IntersectionObserver((ents, obs)=>{
    ents.forEach(en=>{
      if(en.isIntersecting){
        en.target.classList.add('is-in');
        obs.unobserve(en.target);
      }
    });
  }, { rootMargin: '0px 0px -20% 0px' });
  items.forEach(el=> ioItems.observe(el));
} else {
  items.forEach(el => el.classList.add('is-in'));
}

if(!vals.length) return;

const format = (num, decimals) => {
  if (decimals > 0) {
    return Number(num).toLocaleString(document.documentElement.lang || 'nl-NL', { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
  }
  return Number(num).toLocaleString(document.documentElement.lang || 'nl-NL');
};

const normNum = (s) => {
  const cleaned = String(s).trim().replace(/[^\d.,-]/g, '');
  const lastComma = cleaned.lastIndexOf(',');
  const lastDot   = cleaned.lastIndexOf('.');

  if (lastComma > -1 && lastDot > -1) {
    return lastComma > lastDot
      ? parseFloat(cleaned.replace(/\./g,'').replace(',','.'))
      : parseFloat(cleaned.replace(/,/g,''));
  }

  if (cleaned.includes(',')) {
    return parseFloat(cleaned.replace(/\./g,'').replace(',','.'));
  }

  if (cleaned.includes('.')) {
    const parts = cleaned.split('.');
    const last = parts[parts.length - 1];
    if (/^\d{3}$/.test(last) && parts.length > 1) {
      return parseFloat(cleaned.replace(/\./g,''));
    }
  }

  return parseFloat(cleaned);
};

const start = (el) => {
  const decimals   = parseInt(el.dataset.decimals || '0', 10);
  const prefix     = el.dataset.prefix || '';
  const suffix     = el.dataset.suffix || '';
  const suffixMode = el.dataset.suffixMode || 'always';
  const target     = normNum(el.dataset.target || '0') || 0;

  const finalNode = el.parentElement.querySelector('[data-final]');

  const formatWith = (val, putSuffix) =>
    prefix + format(val, decimals) + (putSuffix ? suffix : '');

  if (prefersReduced) {
    el.textContent = formatWith(target, true);
    if (finalNode) finalNode.textContent = formatWith(target, true);
    return;
  }

  const duration = 1200;
  const t0 = performance.now();
  let lastRenderedInt = null;
  let lastRenderedTxt = '';

  const render = (val, putSuffix) => {
    const txt = formatWith(val, putSuffix);
    if (txt !== lastRenderedTxt) {
      el.textContent = txt;
      lastRenderedTxt = txt;
    }
  };

  const tick = (now) => {
    const p = Math.min(1, (now - t0) / duration);
    const eased = 1 - Math.pow(1 - p, 3);
    let current = target * eased;

    if (decimals === 0) {
      const curInt = Math.floor(current);
      if (curInt !== lastRenderedInt) {
        lastRenderedInt = curInt;
        render(curInt, suffixMode === 'always');
      }
    } else {
      render(current, suffixMode === 'always');
    }

    if (p < 1) requestAnimationFrame(tick);
    else {
      render(target, true);
      if (finalNode) finalNode.textContent = formatWith(target, true);
    }
  };

  requestAnimationFrame(tick);
};

if (canIO) {
  const io = new IntersectionObserver((entries, obs) => {
    entries.forEach((en) => {
      if (en.isIntersecting) {
        start(en.target);
        obs.unobserve(en.target);
      }
    });
  }, { rootMargin: '0px 0px -20% 0px' });

  vals.forEach((el) => io.observe(el));
} else {
  vals.forEach((el) => start(el));
}
    
  }
  function initAll(scope){
    var base = scope && scope.querySelectorAll ? scope : document;
    base.querySelectorAll('.wd-metrics').forEach(init);
    if(scope && scope.matches && scope.matches('.wd-metrics')) init(scope);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ initAll(document); }, { once:true });
  else initAll(document);
  document.addEventListener('shopify:section:load', function(event){ initAll(event.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-product-faq"] && !Shopify.designMode) return;
  try {
    
(function(){function init(root){

if(!root || root.dataset.wdBound === 'true') return;
root.dataset.wdBound = 'true';

root.querySelectorAll('.wd-faq__btn').forEach(function(btn){
  btn.addEventListener('click', function(){
    var expanded = btn.getAttribute('aria-expanded') === 'true';
    var panel = btn.nextElementSibling;

    btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    if(panel){
      if(expanded){
        panel.setAttribute('hidden','hidden');
      }else{
        panel.removeAttribute('hidden');
      }
    }
  });
});
}function initAll(scope){var b=scope&&scope.querySelectorAll?scope:document;b.querySelectorAll('.wd-faq').forEach(init);if(scope&&scope.matches&&scope.matches('.wd-faq'))init(scope);}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initAll(document);},{once:true});else initAll(document);document.addEventListener('shopify:section:load',function(e){initAll(e.target);});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-product-page-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(wrap){

if(!wrap || wrap.dataset.wdBound === 'true') return;
wrap.dataset.wdBound = 'true';


var main = wrap.querySelector('[data-wd-mainimg]');
var thumbs = wrap.querySelectorAll('[data-wd-thumb]');
if(main && thumbs && thumbs.length){
  thumbs.forEach(function(t){
    function act(){
      var url = t.getAttribute('data-wd-thumb');
      if(!url) return;
      var img = main.querySelector('img');
      if(img) img.src = url;
    }
    t.addEventListener('click', act);
    t.addEventListener('keydown', function(e){
      if(e.key === 'Enter' || e.key === ' ') act();
    });
  });
}
    
  }
  function initAll(scope){var b=scope&&scope.querySelectorAll?scope:document;b.querySelectorAll('.wd-ult').forEach(init);if(scope&&scope.matches&&scope.matches('.wd-ult'))init(scope);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initAll(document);},{once:true});else initAll(document);
  document.addEventListener('shopify:section:load',function(e){initAll(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-product-page"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';
  function initTracking(root){

      if(!root || root.dataset.waTrackBound === 'true') return;
      root.dataset.waTrackBound = 'true';

      root.addEventListener('click', function(e){
        var a = e.target && e.target.closest ? e.target.closest('[data-wd-wa-track],[data-wd-wa-tel]') : null;
        if(!a) return;

        var detail = {
          source: a.getAttribute('data-wd-wa-source') || (a.hasAttribute('data-wd-wa-tel') ? 'tel' : 'button'),
          product_id: a.getAttribute('data-wd-product-id') || '',
          variant_id: a.getAttribute('data-wd-variant-id') || '',
          sku: a.getAttribute('data-wd-sku') || '',
          href: a.getAttribute('href') || ''
        };

        try{
          if(window.dataLayer && typeof window.dataLayer.push === 'function'){
            window.dataLayer.push({
              event: a.hasAttribute('data-wd-wa-tel') ? 'phone_click' : 'whatsapp_click',
              wa_source: detail.source,
              product_id: detail.product_id,
              variant_id: detail.variant_id,
              sku: detail.sku
            });
          }
          if(typeof window.gtag === 'function'){
            window.gtag('event', a.hasAttribute('data-wd-wa-tel') ? 'phone_click' : 'whatsapp_click', {
              wa_source: detail.source,
              product_id: detail.product_id,
              variant_id: detail.variant_id,
              sku: detail.sku
            });
          }
          document.dispatchEvent(new CustomEvent('wd:whatsapp:click', { detail: detail }));
        }catch(err){}
      }, true);
    
  }

  function initFaq(root){

      var faq = root.querySelector('[data-wd-faq]');
      if(!faq || faq.dataset.bound === 'true') return;
      faq.dataset.bound = 'true';

      var T_OPEN_ALL = (root.getAttribute('data-wd-faq-open-all') || 'Alles openen');
      var T_CLOSE_ALL = (root.getAttribute('data-wd-faq-close-all') || 'Alles sluiten');
      var T_COPY = (root.getAttribute('data-wd-faq-copy') || 'Kopieer');
      var T_COPIED = (root.getAttribute('data-wd-faq-copied') || 'Gekopieerd');

      var items = Array.prototype.slice.call(faq.querySelectorAll('[data-wd-faq-item]'));
      var listEl = faq.querySelector('[data-wd-faq-list]');
      var emptyEl = faq.querySelector('[data-wd-faq-empty]');
      var searchEl = faq.querySelector('[data-wd-faq-search]');
      var toggleBtn = faq.querySelector('[data-wd-faq-toggle]');
      var accordion = faq.getAttribute('data-accordion') === 'true';
      var productId = faq.getAttribute('data-product-id') || '';

      function dispatch(name, detail){
        try{ document.dispatchEvent(new CustomEvent(name, { detail: detail })); }catch(e){}
      }

      function track(eventName, payload){
        try{
          if(window.dataLayer && typeof window.dataLayer.push === 'function'){
            window.dataLayer.push(Object.assign({ event: eventName, product_id: productId }, payload || {}));
          }
          if(typeof window.gtag === 'function'){
            window.gtag('event', eventName, Object.assign({ product_id: productId }, payload || {}));
          }
        }catch(e){}
      }

      function refreshToggle(){
        if(!toggleBtn) return;
        var allOpen = items.every(function(it){ return it.open; });
        toggleBtn.setAttribute('aria-pressed', allOpen ? 'true' : 'false');
        var t = toggleBtn.querySelector('[data-wd-faq-toggle-text]');
        if(t) t.textContent = allOpen ? T_CLOSE_ALL : T_OPEN_ALL;
      }

      faq.addEventListener('click', function(event){
        var summary=event.target.closest&&event.target.closest('summary');
        if(!summary||!faq.contains(summary))return;
        if(event.target.closest('button,a,input,select,textarea'))return;
        var item=summary.parentElement;
        if(!item.matches('[data-wd-faq-item]'))return;
        event.preventDefault();
        var next=!item.open;
        if(next&&accordion)items.forEach(function(other){if(other!==item)other.open=false;});
        item.open=next;
        refreshToggle();
      });

      items.forEach(function(it){
        it.addEventListener('toggle', function(){
          if(it.open){
            var q = it.getAttribute('data-q') || '';
            var id = it.id || '';
            dispatch('wd:faq:open', { id: id, question: q, product_id: productId });
            track('faq_open', { faq_id: id, faq_question: q });
          }
          refreshToggle();
        });
      });

      if(toggleBtn){
        toggleBtn.addEventListener('click', function(){
          var allOpen = items.every(function(it){ return it.open; });
          items.forEach(function(it){ it.open = !allOpen; });
          refreshToggle();
        });
      }

      // Deeplink: auto-open & scroll based on hash.
      function handleHash(){
        var hash = (window.location.hash || '').replace(/^#/, '');
        if(!hash) return;
        var target = document.getElementById(hash);
        if(!target || !target.matches('[data-wd-faq-item]')) return;
        if(accordion){
          items.forEach(function(other){ if(other !== target) other.open = false; });
        }
        target.open = true;
        window.setTimeout(function(){
          try{ target.scrollIntoView({ behavior:'smooth', block:'start' }); }catch(e){ target.scrollIntoView(); }
          var s = target.querySelector('summary');
          if(s) s.focus({ preventScroll:true });
        }, 60);
      }
      handleHash();
      window.addEventListener('hashchange', handleHash);

      // Search filter.
      if(searchEl){
        var debounce;
        searchEl.addEventListener('input', function(){
          window.clearTimeout(debounce);
          debounce = window.setTimeout(function(){
            var q = (searchEl.value || '').trim().toLowerCase();
            var visible = 0;
            items.forEach(function(it){
              var hay = (it.getAttribute('data-search') || '').toLowerCase();
              var match = q === '' || hay.indexOf(q) !== -1;
              it.hidden = !match;
              if(match) visible++;
            });
            if(emptyEl) emptyEl.hidden = visible !== 0 || q === '';
            if(q) track('faq_search', { faq_query: q, faq_results: visible });
          }, 180);
        });
      }

      // Copy link per item.
      faq.addEventListener('click', function(e){
        var btn = e.target && e.target.closest ? e.target.closest('[data-wd-faq-copy]') : null;
        if(!btn) return;
        e.preventDefault();
        e.stopPropagation();
        var anchor = btn.getAttribute('data-anchor') || '';
        var url = window.location.origin + window.location.pathname + '#' + anchor;
        var done = function(){
          btn.classList.add('is-copied');
          window.setTimeout(function(){ btn.classList.remove('is-copied'); }, 1400);
          track('faq_copy_link', { faq_id: anchor });
        };
        try{
          if(navigator.clipboard && navigator.clipboard.writeText){
            navigator.clipboard.writeText(url).then(done, done);
          } else {
            var ta = document.createElement('textarea');
            ta.value = url;
            ta.style.position = 'fixed';
            ta.style.opacity = '0';
            document.body.appendChild(ta);
            ta.select();
            try{ document.execCommand('copy'); }catch(_){}
            document.body.removeChild(ta);
            done();
          }
        }catch(_){ done(); }
      });

      // Helpful vote.
      faq.addEventListener('click', function(e){
        var vote = e.target && e.target.closest ? e.target.closest('[data-wd-faq-vote]') : null;
        if(!vote) return;
        e.preventDefault();
        var wrap = vote.closest('[data-wd-faq-helpful]');
        if(!wrap || wrap.dataset.voted === 'true') return;
        wrap.dataset.voted = 'true';
        wrap.querySelectorAll('[data-wd-faq-vote]').forEach(function(b){
          if(b === vote) b.classList.add('is-active');
          b.disabled = true;
        });
        var thx = wrap.querySelector('[data-wd-faq-helpful-thanks]');
        if(thx) thx.hidden = false;
        var item = vote.closest('[data-wd-faq-item]');
        track('faq_helpful', {
          faq_id: item ? item.id : '',
          faq_question: item ? (item.getAttribute('data-q') || '') : '',
          faq_vote: vote.getAttribute('data-wd-faq-vote') || ''
        });
      });

      refreshToggle();
    
  }

  function init(root){ initTracking(root); initFaq(root); }
  function initAll(scope){
    var c=scope&&scope.querySelectorAll?scope:document;
    c.querySelectorAll('[data-wd-product-page]').forEach(init);
    if(scope&&scope.matches&&scope.matches('[data-wd-product-page]')) init(scope);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){initAll(document);},{once:true}); else initAll(document);
  document.addEventListener('shopify:section:load',function(e){initAll(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-recently-viewed-products"] && !Shopify.designMode) return;
  try {
    

  (function(){

    'use strict';


    var instances = new Map();


    function parse(value,fallback){

      try{

        var parsed = JSON.parse(value);

        return parsed == null
          ? fallback
          : parsed;

      }catch(e){

        return fallback;

      }

    }


    function rootUrl(){

      var value =
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';


      return value.charAt(value.length - 1) === '/'
        ? value
        : value + '/';

    }


    function entry(value){

      if(
        typeof value === 'string' &&
        value
      ){

        return {
          handle:value,
          viewedAt:null
        };

      }


      if(
        value &&
        typeof value === 'object' &&
        value.handle
      ){

        return {
          handle:String(value.handle),
          viewedAt:value.viewedAt || null
        };

      }


      return null;

    }


    function formatViewedAt(
      value,
      locale,
      labels
    ){

      if(!value){
        return '';
      }


      var date = new Date(value);


      if(isNaN(date.getTime())){
        return '';
      }


      var now = new Date();


      var today = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate()
      );


      var viewed = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate()
      );


      var diff =
        Math.round(
          (today - viewed) /
          86400000
        );


      var time =
        date.toLocaleTimeString(
          locale,
          {
            hour:'2-digit',
            minute:'2-digit'
          }
        );


      if(diff === 0){

        return (
          labels.viewed +
          ' ' +
          labels.today +
          ' ' +
          labels.at +
          ' ' +
          time
        );

      }


      if(diff === 1){

        return (
          labels.viewed +
          ' ' +
          labels.yesterday +
          ' ' +
          labels.at +
          ' ' +
          time
        );

      }


      return (
        labels.viewed +
        ' ' +
        date.toLocaleDateString(
          locale,
          {
            day:'numeric',
            month:'short',
            year:
              date.getFullYear() !== now.getFullYear()
                ? 'numeric'
                : undefined
          }
        ) +
        ' ' +
        labels.at +
        ' ' +
        time
      );

    }


    function init(section){

      if(
        !section ||
        instances.has(section)
      ){
        return;
      }


      var root =
        section.querySelector(
          '[data-wd-rv-wrap]'
        );


      var grid =
        section.querySelector(
          '[data-wd-rv-grid]'
        );


      if(
        !root ||
        !grid
      ){
        return;
      }


      var empty =
        section.querySelector(
          '[data-wd-rv-empty]'
        );


      var nav =
        section.querySelector(
          '[data-wd-rv-navigation]'
        );


      var prev =
        section.querySelector(
          '[data-wd-rv-prev]'
        );


      var next =
        section.querySelector(
          '[data-wd-rv-next]'
        );


      var progress =
        section.querySelector(
          '[data-wd-rv-progress]'
        );


      var titleEl =
        section.querySelector(
          '[data-wd-rv-title]'
        );


      var fallbackAction =
        section.querySelector(
          '[data-wd-rv-fallback-action]'
        );


      var fallbackLink =
        section.querySelector(
          '[data-wd-rv-fallback-link]'
        );


      var fallbackScript =
        root.querySelector(
          '[data-wd-rv-fallback-products]'
        );


      var limit =
        Math.max(
          1,
          parseInt(
            root.dataset.limit || '8',
            10
          ) || 8
        );


      var storageKey =
        root.dataset.storageKey ||
        'wd_recently_viewed';


      var current =
        root.dataset.currentHandle ||
        '';


      var locale =
        root.dataset.locale ||
        document.documentElement.lang ||
        'nl-NL';


      var currency =
        root.dataset.currency ||
        'EUR';


      var vatRate =
        Number(
          root.dataset.vatRate ||
          21
        );


      var taxesIncluded =
        root.dataset.taxesIncluded === 'true';


      var desktopVisible =
        Math.max(
          1,
          parseInt(
            root.dataset.desktopVisible || '4',
            10
          ) || 4
        );


      var recentTitle =
        root.dataset.recentTitle ||
        'Onlangs bekeken';


      var fallbackTitle =
        root.dataset.fallbackTitle ||
        '';


      var fallbackUrl =
        root.dataset.fallbackUrl ||
        '';


      var hideWhenEmpty =
        root.dataset.hideWhenEmpty === 'true';


      var stopped = false;


      var controller =
        typeof AbortController === 'function'
          ? new AbortController()
          : null;


      var listeners = [];


      var cachePrefix =
        'wd_rv_cache_v6:' +
        locale +
        ':' +
        currency +
        ':';


      var labels = {

        viewed:
          root.dataset.trViewed ||
          'Bekeken',

        today:
          root.dataset.trToday ||
          'vandaag',

        yesterday:
          root.dataset.trYesterday ||
          'gisteren',

        at:
          root.dataset.trAt ||
          'om',

        of:
          root.dataset.trOf ||
          'van'

      };


      var cardLabels = {

        sku:'SKU',

        view:
          root.dataset.btnText ||
          'Bekijk onderdeel',

        viewAria:
          (
            root.dataset.btnText ||
            'Bekijk onderdeel'
          ) + ': ',

        prices:
          root.dataset.trSeePrices ||
          'Zie prijzen',

        from:
          root.dataset.trFrom ||
          'Vanaf',

        vatIncl:
          root.dataset.trVatIncl ||
          'incl. btw',

        vatExcl:
          root.dataset.trVatExcl ||
          'excl. btw',

        add:
          root.dataset.trAdd ||
          'In winkelwagen',

        added:
          root.dataset.trAdded ||
          'Toegevoegd',

        available:
          'Beschikbaar',

        out:
          root.dataset.trOos ||
          'Niet op voorraad'

      };


      function on(
        target,
        type,
        handler,
        options
      ){

        if(!target){
          return;
        }


        target.addEventListener(
          type,
          handler,
          options
        );


        listeners.push(
          function(){

            target.removeEventListener(
              type,
              handler,
              options
            );

          }
        );

      }


      function list(){

        var raw = '[]';


        try{

          raw =
            localStorage.getItem(
              storageKey
            ) || '[]';

        }catch(e){}


        var values =
          parse(
            raw,
            []
          );


        if(!Array.isArray(values)){
          return [];
        }


        var seen = {};


        return values
          .map(entry)
          .filter(
            function(item){

              if(
                !item ||
                seen[item.handle]
              ){
                return false;
              }


              seen[item.handle] = true;

              return true;

            }
          );

      }


      function save(values){

        try{

          localStorage.setItem(
            storageKey,
            JSON.stringify(values)
          );

        }catch(e){}

      }


      function addCurrent(){

        if(!current){
          return;
        }


        var values =
          list().filter(
            function(item){

              return item.handle !== current;

            }
          );


        values.unshift(
          {
            handle:current,
            viewedAt:new Date().toISOString()
          }
        );


        save(
          values.slice(0,50)
        );

      }


      function cacheRead(handle){

        try{

          var cached =
            parse(
              sessionStorage.getItem(
                cachePrefix + handle
              ) || 'null',
              null
            );


          if(
            cached &&
            cached.time &&
            Date.now() - cached.time < 1800000
          ){

            return cached.data;

          }

        }catch(e){}


        return null;

      }


      function cacheWrite(
        handle,
        data
      ){

        try{

          sessionStorage.setItem(
            cachePrefix + handle,
            JSON.stringify(
              {
                time:Date.now(),
                data:data
              }
            )
          );

        }catch(e){}

      }


      async function fetchProduct(handle){

        var cached =
          cacheRead(handle);


        if(cached){
          return cached;
        }


        var response =
          await fetch(
            rootUrl() +
            'products/' +
            encodeURIComponent(handle) +
            '.js',
            {
              credentials:'same-origin',

              signal:
                controller
                  ? controller.signal
                  : undefined,

              headers:{
                Accept:'application/json'
              }
            }
          );


        if(!response.ok){

          var error =
            new Error(
              'Product request failed'
            );


          error.status =
            response.status;


          throw error;

        }


        var data =
          await response.json();


        cacheWrite(
          handle,
          data
        );


        return data;

      }


      async function load(entries){

        var output =
          new Array(
            entries.length
          );


        var cursor = 0;


        async function worker(){

          while(
            cursor < entries.length
          ){

            var index =
              cursor++;


            try{

              output[index] = {

                product:
                  await fetchProduct(
                    entries[index].handle
                  ),

                viewedAt:
                  entries[index].viewedAt

              };

            }catch(error){

              output[index] = {

                error:error,

                handle:
                  entries[index].handle

              };

            }

          }

        }


        await Promise.all(
          Array.from(
            {
              length:
                Math.min(
                  6,
                  entries.length
                )
            },
            worker
          )
        );


        return output;

      }


      function readFallbackEntries(){

        if(!fallbackScript){
          return [];
        }


        var values =
          parse(
            fallbackScript.textContent || '[]',
            []
          );


        if(!Array.isArray(values)){
          return [];
        }


        var seen = {};


        return values
          .map(entry)
          .filter(
            function(item){

              if(
                !item ||
                !item.handle ||
                item.handle === current ||
                seen[item.handle]
              ){
                return false;
              }


              seen[item.handle] = true;

              return true;

            }
          )
          .slice(
            0,
            limit
          );

      }


      function setTitle(value){

        if(!titleEl){
          return;
        }


        titleEl.textContent =
          value ||
          recentTitle;

      }


      function hideFallbackAction(){

        if(fallbackAction){
          fallbackAction.hidden = true;
        }


        if(fallbackLink){
          fallbackLink.removeAttribute(
            'href'
          );
        }

      }


      function showFallbackAction(){

        if(
          !fallbackAction ||
          !fallbackLink ||
          !fallbackUrl
        ){

          hideFallbackAction();

          return;

        }


        fallbackLink.href =
          fallbackUrl;


        fallbackLink.textContent =
          root.dataset.fallbackButtonText ||
          'Bekijk alle onderdelen';


        fallbackAction.hidden =
          false;

      }


      function showSection(){

        section.hidden = false;

      }


      function renderEmpty(){

        section.setAttribute(
          'data-item-count',
          '0'
        );


        section.setAttribute(
          'data-mode',
          'empty'
        );


        setTitle(
          recentTitle
        );


        grid.classList.remove(
          'is-loading'
        );


        grid.classList.remove(
          'is-scrollable'
        );


        grid.setAttribute(
          'aria-busy',
          'false'
        );


        grid.innerHTML = '';


        if(nav){
          nav.hidden = true;
        }


        hideFallbackAction();


        if(
          hideWhenEmpty &&
          !(
            window.Shopify &&
            window.Shopify.designMode
          )
        ){

          if(empty){
            empty.classList.remove(
              'is-active'
            );
          }


          section.hidden = true;

          return;

        }


        showSection();


        if(empty){

          empty.classList.add(
            'is-active'
          );

        }

      }


      function renderItems(
        items,
        mode
      ){

        if(stopped){
          return;
        }


        var invalid = [];

        var html = [];


        items.forEach(
          function(item){

            if(
              item &&
              item.product &&
              window.WDProductCard
            ){

              var metaText = '';


              if(mode === 'recent'){

                metaText =
                  formatViewedAt(
                    item.viewedAt,
                    locale,
                    labels
                  );

              }


              html.push(
                '<li>' +
                window.WDProductCard.render(
                  item.product,
                  {
                    context:
                      mode === 'fallback'
                        ? 'primary-collection-fallback'
                        : 'recently-viewed',

                    locale:locale,

                    currency:currency,

                    vatRate:vatRate,

                    taxesIncluded:taxesIncluded,

                    rootUrl:rootUrl(),

                    placeholderUrl:
                      root.dataset.placeholderUrl ||
                      '',

                    showQuickAdd:true,

                    showSku:true,

                    showStock:true,

                    stripStoreName:true,

                    metaText:metaText,

                    labels:cardLabels
                  }
                ) +
                '</li>'
              );

            }else if(
              mode === 'recent' &&
              item &&
              item.error &&
              item.error.status === 404
            ){

              invalid.push(
                item.handle
              );

            }

          }
        );


        if(
          mode === 'recent' &&
          invalid.length
        ){

          save(
            list().filter(
              function(item){

                return (
                  invalid.indexOf(
                    item.handle
                  ) === -1
                );

              }
            )
          );

        }


        if(!html.length){

          if(mode === 'recent'){

            renderFallback();

          }else{

            renderEmpty();

          }


          return;

        }


        showSection();


        section.setAttribute(
          'data-item-count',
          String(html.length)
        );


        section.setAttribute(
          'data-mode',
          mode
        );


        grid.innerHTML =
          html.join('');


        grid.classList.remove(
          'is-loading'
        );


        grid.setAttribute(
          'aria-busy',
          'false'
        );


        if(empty){

          empty.classList.remove(
            'is-active'
          );

        }


        if(mode === 'fallback'){

          setTitle(
            fallbackTitle ||
            recentTitle
          );


          grid.setAttribute(
            'aria-label',
            fallbackTitle ||
            recentTitle
          );


          showFallbackAction();

        }else{

          setTitle(
            recentTitle
          );


          grid.setAttribute(
            'aria-label',
            recentTitle
          );


          hideFallbackAction();

        }


        requestAnimationFrame(
          update
        );

      }


      function renderFallback(){

        var entries =
          readFallbackEntries();


        if(
          !fallbackTitle ||
          !entries.length
        ){

          renderEmpty();

          return;

        }


        showSection();


        setTitle(
          fallbackTitle
        );


        grid.setAttribute(
          'aria-label',
          fallbackTitle
        );


        load(entries)
          .then(
            function(items){

              renderItems(
                items,
                'fallback'
              );

            }
          )
          .catch(
            function(){

              renderEmpty();

            }
          );

      }


      function renderRecent(items){

        renderItems(
          items,
          'recent'
        );

      }


      function update(){

        if(stopped){
          return;
        }


        var count =
          grid.children.length;


        var show =
          count > desktopVisible &&
          window.innerWidth >= 990;


        grid.classList.toggle(
          'is-scrollable',
          show
        );


        if(
          window.innerWidth < 990
        ){

          if(nav){
            nav.hidden = true;
          }


          return;

        }


        if(nav){

          nav.hidden =
            !show;

        }


        if(!count){
          return;
        }


        if(!show){

          grid.scrollLeft = 0;

          return;

        }


        var card =
          grid.querySelector('li');


        if(!card){
          return;
        }


        var gap =
          parseFloat(
            getComputedStyle(grid).gap ||
            '16'
          ) || 16;


        var step =
          card.getBoundingClientRect().width +
          gap;


        var start =
          Math.max(
            1,
            Math.round(
              grid.scrollLeft /
              step
            ) + 1
          );


        var end =
          Math.min(
            count,
            start +
            desktopVisible -
            1
          );


        if(progress){

          progress.textContent =
            start +
            '–' +
            end +
            ' ' +
            labels.of +
            ' ' +
            count;

        }


        if(prev){

          prev.disabled =
            grid.scrollLeft <= 2;

        }


        if(next){

          next.disabled =
            (
              grid.scrollLeft +
              grid.clientWidth
            ) >=
            (
              grid.scrollWidth -
              2
            );

        }

      }


      function scroll(direction){

        var card =
          grid.querySelector('li');


        if(!card){
          return;
        }


        var gap =
          parseFloat(
            getComputedStyle(grid).gap ||
            '16'
          ) || 16;


        grid.scrollBy(
          {
            left:
              direction *
              (
                card.getBoundingClientRect().width +
                gap
              ) *
              desktopVisible,

            behavior:
              matchMedia(
                '(prefers-reduced-motion: reduce)'
              ).matches
                ? 'auto'
                : 'smooth'
          }
        );

      }


      addCurrent();


      var entries =
        list()
          .filter(
            function(item){

              return (
                item.handle !== current
              );

            }
          )
          .slice(
            0,
            limit
          );


      if(!entries.length){

        renderFallback();

      }else{

        load(entries)
          .then(
            renderRecent
          )
          .catch(
            renderFallback
          );

      }


      on(
        prev,
        'click',
        function(){

          scroll(-1);

        }
      );


      on(
        next,
        'click',
        function(){

          scroll(1);

        }
      );


      on(
        grid,
        'scroll',
        function(){

          requestAnimationFrame(
            update
          );

        },
        {
          passive:true
        }
      );


      on(
        window,
        'resize',
        function(){

          requestAnimationFrame(
            update
          );

        },
        {
          passive:true
        }
      );


      instances.set(
        section,
        {
          destroy:function(){

            stopped = true;


            if(controller){
              controller.abort();
            }


            listeners.forEach(
              function(off){

                off();

              }
            );


            instances.delete(
              section
            );

          }
        }
      );

    }


    function destroy(section){

      var instance =
        instances.get(section);


      if(instance){
        instance.destroy();
      }

    }


    function boot(scope){

      (
        scope ||
        document
      )
        .querySelectorAll(
          '[data-wd-rv-section]'
        )
        .forEach(init);

    }


    boot(document);


    if(
      !window.WDRecentlyViewedLifecycleBound
    ){

      window.WDRecentlyViewedLifecycleBound =
        true;


      document.addEventListener(
        'shopify:section:load',
        function(event){

          boot(
            event.target
          );

        }
      );


      document.addEventListener(
        'shopify:section:unload',
        function(event){

          destroy(
            event.target
          );

        }
      );

    }

  })();

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-search-results"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initWdSearch(root){
    
      if(!root || root.getAttribute('data-ws-initialized') === 'true') return;
      root.setAttribute('data-ws-initialized','true');
    
      var CFG = {};
      var configNode = root.querySelector('[data-wd-search-config]');
      if(configNode){ try{ CFG = JSON.parse(configNode.textContent || '{}'); }catch(_){ CFG = {}; } }
      var searchPerformed = root.getAttribute('data-ws-performed') === 'true';
      var searchEmpty = root.getAttribute('data-ws-empty') === 'true';
    
      document.documentElement.classList.remove('wd-search-empty-state','wd-search-has-results');
      document.documentElement.classList.add(searchEmpty ? 'wd-search-empty-state' : 'wd-search-has-results');
    
      function clearStaleMobileSearchState(){
        document.documentElement.classList.remove('wd-drawer-open','ws-filter-lock');
        document.body.classList.remove('wd-drawer-open','ws-filter-lock');
    
        var openDrawers = document.querySelectorAll('dialog.wd-drawer[open]');
        for(var drawerIndex=0;drawerIndex<openDrawers.length;drawerIndex++){
          try{
            if(typeof openDrawers[drawerIndex].close === 'function') openDrawers[drawerIndex].close();
            else openDrawers[drawerIndex].removeAttribute('open');
          }catch(error){
            openDrawers[drawerIndex].removeAttribute('open');
          }
        }
      }
    
      function disableMobileSearchTransition(){
        try{
          if(!window.matchMedia || !window.matchMedia('(max-width:989px)').matches) return;
          var viewTransitionMeta = document.querySelector('meta[name="view-transition"]');
          if(viewTransitionMeta) viewTransitionMeta.remove();
        }catch(error){}
      }
    
      clearStaleMobileSearchState();
      window.addEventListener('pageshow',clearStaleMobileSearchState);
    
      var pageSearchForms = root.querySelectorAll('form[role="search"]');
      for(var searchFormIndex=0;searchFormIndex<pageSearchForms.length;searchFormIndex++){
        pageSearchForms[searchFormIndex].addEventListener('submit',function(){
          disableMobileSearchTransition();
          clearStaleMobileSearchState();
        });
      }
    
      if(searchPerformed){
      try{
        var currentUrl = new URL(window.location.href);
        var originalVisibleQuery = currentUrl.searchParams.get('wd_original_q') || '';
    
        if(originalVisibleQuery){
          var visibleSearchInputs = root.querySelectorAll('input[type="search"][name="q"]');
          for(var visibleInputIndex=0;visibleInputIndex<visibleSearchInputs.length;visibleInputIndex++){
            visibleSearchInputs[visibleInputIndex].value = originalVisibleQuery;
          }
    
          var searchHeading = root.querySelector('.ws-header__title');
          if(searchHeading){
            var headingText = searchHeading.textContent || '';
            var quoteStart = headingText.indexOf('“');
            if(quoteStart !== -1){
              searchHeading.textContent = headingText.slice(0,quoteStart) + '“' + originalVisibleQuery + '”';
            }
          }
    
          var syntheticQuery = currentUrl.searchParams.get('q') || '';
          if(syntheticQuery && document.title.indexOf(syntheticQuery) !== -1){
            document.title = document.title.split(syntheticQuery).join(originalVisibleQuery);
          }
    
          var preserveForms = root.querySelectorAll('form:not([role="search"])');
          for(var preserveFormIndex=0;preserveFormIndex<preserveForms.length;preserveFormIndex++){
            if(!preserveForms[preserveFormIndex].querySelector('input[name="wd_original_q"]')){
              var originalField = document.createElement('input');
              originalField.type = 'hidden';
              originalField.name = 'wd_original_q';
              originalField.value = originalVisibleQuery;
              preserveForms[preserveFormIndex].appendChild(originalField);
            }
    
            if(!preserveForms[preserveFormIndex].querySelector('input[name="wd_title_fallback"]')){
              var fallbackField = document.createElement('input');
              fallbackField.type = 'hidden';
              fallbackField.name = 'wd_title_fallback';
              fallbackField.value = '1';
              preserveForms[preserveFormIndex].appendChild(fallbackField);
            }
          }
    
          var preserveLinks = root.querySelectorAll('a[href]');
          for(var preserveLinkIndex=0;preserveLinkIndex<preserveLinks.length;preserveLinkIndex++){
            try{
              var preserveUrl = new URL(preserveLinks[preserveLinkIndex].href,window.location.origin);
              if(preserveUrl.pathname.indexOf('/search') !== -1 && preserveUrl.searchParams.get('q')){
                preserveUrl.searchParams.set('wd_original_q',originalVisibleQuery);
                preserveUrl.searchParams.set('wd_title_fallback','1');
                preserveLinks[preserveLinkIndex].href = preserveUrl.toString();
              }
            }catch(linkError){}
          }
        }
    
        if(currentUrl.pathname.indexOf('/search') !== -1 && currentUrl.searchParams.get('q') && currentUrl.searchParams.get('type') !== 'product'){
          currentUrl.searchParams.set('type','product');
          currentUrl.searchParams.set('options[prefix]','last');
          disableMobileSearchTransition();
          clearStaleMobileSearchState();
          window.location.replace(currentUrl.toString());
          return;
        }
    
        if(searchEmpty){
        var rawQuery = (currentUrl.searchParams.get('q') || '').trim();
        var fallbackAlreadyUsed = currentUrl.searchParams.get('wd_title_fallback') === '1';
        var containsSearchSyntax = /[:"()]/.test(rawQuery) || /\s(?:AND|OR|NOT)\s/i.test(rawQuery) || /^-/.test(rawQuery);
    
        if(rawQuery && !fallbackAlreadyUsed && !containsSearchSyntax){
          var titleTerms = rawQuery
            .split(/\s+/)
            .filter(function(term){return term !== '';})
            .map(function(term){
              var cleanTerm = term.replace(/[\\]/g,'').replace(/"/g,'');
              return cleanTerm ? 'title:' + cleanTerm : '';
            })
            .filter(function(term){return term !== '';})
            .join(' ');
    
          if(titleTerms){
            currentUrl.searchParams.set('q',titleTerms);
            currentUrl.searchParams.set('wd_original_q',rawQuery);
            currentUrl.searchParams.set('wd_title_fallback','1');
            currentUrl.searchParams.set('type','product');
            currentUrl.searchParams.set('options[prefix]','last');
            disableMobileSearchTransition();
            clearStaleMobileSearchState();
            window.location.replace(currentUrl.toString());
            return;
          }
        }
        }
      }catch(error){}
      }
    
      var productsRoot = root.querySelector('[data-ws-products]');
      var mobileMedia = window.matchMedia('(max-width:749px)');
      var isMobile = function(){return mobileMedia.matches;};
      var storageKey = function(){return isMobile() ? 'wd_search_product_view_mobile' : 'wd_search_product_view_desktop';};
      var currentViewport = isMobile() ? 'mobile' : 'desktop';
    
      function preferredView(){
        if(!productsRoot) return 'grid';
        var fallback = isMobile()
          ? productsRoot.getAttribute('data-default-mobile-view') || 'list'
          : productsRoot.getAttribute('data-default-view') || 'grid';
        try{return window.localStorage.getItem(storageKey()) || fallback;}catch(error){return fallback;}
      }
    
      function applyView(view,persist){
        if(!productsRoot) return;
        var safeView = view === 'list' ? 'list' : 'grid';
        productsRoot.classList.toggle('is-list-view',safeView === 'list');
        productsRoot.classList.toggle('is-grid-view',safeView === 'grid');
        productsRoot.setAttribute('data-current-view',safeView);
    
        var buttons = productsRoot.querySelectorAll('[data-ws-view]');
        for(var i=0;i<buttons.length;i++){
          var active = buttons[i].getAttribute('data-ws-view') === safeView;
          buttons[i].classList.toggle('is-active',active);
          buttons[i].setAttribute('aria-pressed',active ? 'true' : 'false');
        }
    
        if(persist){
          try{window.localStorage.setItem(storageKey(),safeView);}catch(error){}
        }
      }
    
      if(productsRoot){
        applyView(preferredView(),false);
    
        root.addEventListener('click',function(event){
          var button = event.target.closest ? event.target.closest('[data-ws-view]') : null;
          if(!button) return;
          event.preventDefault();
          applyView(button.getAttribute('data-ws-view'),true);
        });
    
        var handleViewportChange = function(){
          var nextViewport = isMobile() ? 'mobile' : 'desktop';
          if(nextViewport === currentViewport) return;
          currentViewport = nextViewport;
          applyView(preferredView(),false);
        };
    
        if(typeof mobileMedia.addEventListener === 'function'){
          mobileMedia.addEventListener('change',handleViewportChange);
        }else if(typeof mobileMedia.addListener === 'function'){
          mobileMedia.addListener(handleViewportChange);
        }
      }
    
      var sidebar = root.querySelector('[data-ws-sidebar]');
      var panel = root.querySelector('[data-ws-filter-panel]');
      var overlay = root.querySelector('.ws-filter-overlay');
      var openButtons = root.querySelectorAll('[data-ws-filter-open]');
      var closeButtons = root.querySelectorAll('[data-ws-filter-close]');
      var lastTrigger = null;
    
      function lockPage(lock){
        document.documentElement.classList.toggle('ws-filter-lock',lock);
        document.body.classList.toggle('ws-filter-lock',lock);
      }
    
      function resetFilterDrawerState(){
        lockPage(false);
    
        if(panel){
          panel.classList.remove('is-open');
          panel.setAttribute(
            'aria-hidden',
            window.matchMedia('(max-width:991px)').matches ? 'true' : 'false'
          );
        }
    
        if(overlay){
          overlay.hidden = true;
          overlay.setAttribute('aria-hidden','true');
        }
    
        for(var i=0;i<openButtons.length;i++){
          openButtons[i].setAttribute('aria-expanded','false');
        }
      }
    
      resetFilterDrawerState();
    
      function openFilters(trigger){
        if(!panel) return;
        lastTrigger = trigger || document.activeElement;
        panel.classList.add('is-open');
        panel.setAttribute('aria-hidden','false');
        if(overlay){
          overlay.hidden = false;
          overlay.setAttribute('aria-hidden','false');
        }
        for(var i=0;i<openButtons.length;i++) openButtons[i].setAttribute('aria-expanded','true');
        lockPage(true);
        window.setTimeout(function(){
          var focusTarget = panel.querySelector('input,button,a[href],summary');
          if(focusTarget) focusTarget.focus();
        },30);
      }
    
      function closeFilters(){
        if(!panel) return;
        panel.classList.remove('is-open');
        if(window.matchMedia('(max-width:991px)').matches) panel.setAttribute('aria-hidden','true');
        if(overlay){
          overlay.hidden = true;
          overlay.setAttribute('aria-hidden','true');
        }
        for(var i=0;i<openButtons.length;i++) openButtons[i].setAttribute('aria-expanded','false');
        lockPage(false);
        if(lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
      }
    
      for(var oi=0;oi<openButtons.length;oi++) openButtons[oi].addEventListener('click',function(){openFilters(this);});
      for(var ci=0;ci<closeButtons.length;ci++) closeButtons[ci].addEventListener('click',closeFilters);
    
      window.addEventListener('resize',function(){
        if(!panel) return;
        if(window.matchMedia('(min-width:992px)').matches){
          panel.classList.remove('is-open');
          panel.setAttribute('aria-hidden','false');
          if(overlay){
            overlay.hidden = true;
            overlay.setAttribute('aria-hidden','true');
          }
          lockPage(false);
        }else if(!panel.classList.contains('is-open')){
          panel.setAttribute('aria-hidden','true');
        }
      });
    
      document.addEventListener('keydown',function(event){
        if(event.key === 'Escape' && panel && panel.classList.contains('is-open')) closeFilters();
      });
    
      window.addEventListener('pageshow',function(){
        resetFilterDrawerState();
      });
    
      function restoreOptions(group){
        var limit = parseInt(group.getAttribute('data-value-limit') || '6',10);
        var options = group.querySelectorAll('[data-wk-filter-option]');
        var more = group.querySelector('[data-wk-filter-more]');
        var expanded = more && more.getAttribute('aria-expanded') === 'true';
        for(var i=0;i<options.length;i++) options[i].hidden = !expanded && i >= limit;
        if(more){
          var label = more.querySelector('[data-wk-filter-more-label]');
          if(label) label.textContent = expanded ? more.getAttribute('data-less-label') : more.getAttribute('data-more-label');
        }
      }
    
      var groups = root.querySelectorAll('[data-wk-filter-group]');
      for(var gi=0;gi<groups.length;gi++){
        (function(group){
          var more = group.querySelector('[data-wk-filter-more]');
          var searchInput = group.querySelector('[data-wk-filter-search]');
          var empty = group.querySelector('[data-wk-filter-empty]');
    
          if(more){
            more.addEventListener('click',function(){
              var expanded = this.getAttribute('aria-expanded') === 'true';
              this.setAttribute('aria-expanded',expanded ? 'false' : 'true');
              restoreOptions(group);
            });
          }
    
          if(searchInput){
            searchInput.addEventListener('input',function(){
              var query = (this.value || '').trim().toLowerCase();
              var options = group.querySelectorAll('[data-wk-filter-option]');
              var matches = 0;
              if(query === ''){
                if(more) more.hidden = false;
                if(empty) empty.hidden = true;
                restoreOptions(group);
                return;
              }
              if(more) more.hidden = true;
              for(var i=0;i<options.length;i++){
                var label = options[i].getAttribute('data-filter-label') || '';
                var match = label.indexOf(query) !== -1;
                options[i].hidden = !match;
                if(match) matches++;
              }
              if(empty) empty.hidden = matches > 0;
            });
          }
        })(groups[gi]);
      }
    
      var filterForm = root.querySelector('[data-ws-filter-form]');
      var submitTimer = null;
      if(filterForm && filterForm.getAttribute('data-auto-submit') === 'true'){
        filterForm.addEventListener('change',function(event){
          window.clearTimeout(submitTimer);
          submitTimer = window.setTimeout(function(){
            if(typeof filterForm.requestSubmit === 'function') filterForm.requestSubmit();
            else filterForm.submit();
          },event.target && event.target.type === 'number' ? 500 : 180);
        });
      }
    
      var grid = root.querySelector('[data-ws-product-grid]');
      var loadMore = root.querySelector('[data-ws-load-more]');
      var visibleCount = root.querySelector('[data-ws-visible-count]');
      var loadStatus = root.querySelector('[data-ws-load-more-status]');
      var loadBusy = false;
    
      function updateVisibleCount(){
        if(!grid || !visibleCount) return;
        visibleCount.textContent = grid.querySelectorAll(':scope > [data-ws-card]').length;
      }
    
      if(loadMore && grid){
        loadMore.addEventListener('click',function(event){
          event.preventDefault();
          if(loadBusy) return;
          var nextUrl = loadMore.getAttribute('href');
          if(!nextUrl) return;
    
          loadBusy = true;
          loadMore.classList.add('is-loading');
          loadMore.setAttribute('aria-busy','true');
          var label = loadMore.querySelector('[data-ws-load-more-label]');
          var loading = loadMore.querySelector('[data-ws-load-more-loading]');
          if(label) label.hidden = true;
          if(loading) loading.hidden = false;
    
          fetch(nextUrl,{headers:{'X-Requested-With':'XMLHttpRequest'}})
            .then(function(response){
              if(!response.ok) throw new Error('load_failed');
              return response.text();
            })
            .then(function(html){
              var doc = new DOMParser().parseFromString(html,'text/html');
              var fetchedRoot = doc.querySelector('.wd-search-results');
              var fetchedGrid = fetchedRoot ? fetchedRoot.querySelector('[data-ws-product-grid]') : null;
              if(!fetchedGrid) throw new Error('grid_missing');
    
              var existing = {};
              var existingCards = grid.querySelectorAll(':scope > [data-ws-card]');
              for(var i=0;i<existingCards.length;i++) existing[existingCards[i].getAttribute('data-product-url')] = true;
    
              var fetchedCards = fetchedGrid.querySelectorAll(':scope > [data-ws-card]');
              var appended = 0;
              for(var j=0;j<fetchedCards.length;j++){
                var url = fetchedCards[j].getAttribute('data-product-url');
                if(url && existing[url]) continue;
                grid.appendChild(fetchedCards[j]);
                if(url) existing[url] = true;
                appended++;
              }
    
              var fetchedNext = fetchedRoot.querySelector('[data-ws-load-more]');
              if(fetchedNext && fetchedNext.getAttribute('href')) loadMore.setAttribute('href',fetchedNext.getAttribute('href'));
              else loadMore.remove();
    
              updateVisibleCount();
              if(loadStatus) loadStatus.textContent = appended + ' ' + CFG.moreLoaded;
            })
            .catch(function(){
              if(loadStatus) loadStatus.textContent = CFG.loadFailed;
              window.location.href = nextUrl;
            })
            .finally(function(){
              loadBusy = false;
              if(loadMore && loadMore.isConnected){
                loadMore.classList.remove('is-loading');
                loadMore.removeAttribute('aria-busy');
                if(label) label.hidden = false;
                if(loading) loading.hidden = true;
              }
            });
        });
      }
    
  }

  function initAll(scope){
    var roots=[];
    if(scope && scope.matches && scope.matches('.wd-search-results')) roots.push(scope);
    if(scope && scope.querySelectorAll) roots=roots.concat(Array.prototype.slice.call(scope.querySelectorAll('.wd-search-results')));
    roots.forEach(initWdSearch);
  }
  initAll(document);
  document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-tractor-parts-popup"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';
  function init(root){

      if(!root || root.dataset.hsxBound==='1') return;
      root.dataset.hsxBound='1';

      const modal = root.querySelector('.hsx-modal');
      const dialogBox = root.querySelector('.hsx-dialog');
      const openBtn = root.querySelector('.hsx-open');
      const closeBtn = root.querySelector('[data-x-close]');
      const slides = root.querySelectorAll('.hsx-slide');
      const prevBtn = root.querySelector('[data-x-prev]');
      const nextBtn = root.querySelector('[data-x-next]');
      const prevMini = root.querySelector('[data-x-prev-mini]');
      const nextMini = root.querySelector('[data-x-next-mini]');
      const thumbs = root.querySelectorAll('.hsx-thumb');
      const legend = root.querySelector('[data-x-legend]');
      const preview = root.querySelector('[data-x-preview]');
      const pvImg = root.querySelector('[data-x-preview-img]');
      const pvTitle = root.querySelector('[data-x-preview-title]');
      const pvPrice = root.querySelector('[data-x-preview-price]');
      const pvCompare = root.querySelector('[data-x-preview-compare]');
      const pvLink = root.querySelector('[data-x-preview-link]');
      const pvClose = root.querySelector('[data-x-preview-close]');
      const pageCountEl = root.querySelector('[data-x-pagecount]');
      const pageTitleEl = root.querySelector('[data-x-page-title]');

      let index = 0;
      const total = slides.length;
      let lastFocus = null;

      function lockScroll(lock){
        document.documentElement.style.scrollbarGutter = lock ? 'stable' : '';
        document.body.style.overflow = lock ? 'hidden' : '';
      }

      function openModal(){
        lastFocus = document.activeElement;
        if(modal && modal.showModal){
          modal.showModal();
        } else if(modal){
          modal.setAttribute('open','');
        }
        lockScroll(true);
        update();
        dialogBox && dialogBox.focus();
      }

      function closeModal(){
        if(modal && modal.close){
          modal.close();
        } else if(modal){
          modal.removeAttribute('open');
        }
        lockScroll(false);
        hidePreview();
        if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
      }

      function showPreview(data){
        if(!preview) return;
        if(pvImg){
          pvImg.src = data.image || '';
          pvImg.alt = data.title || '';
        }
        if(pvTitle){
          pvTitle.textContent = data.title || '';
          pvTitle.setAttribute('href', data.url || '#');
        }
        if(pvPrice) pvPrice.textContent = data.price || '';
        if(pvCompare){
          if(data.compare){
            pvCompare.textContent = data.compare;
            pvCompare.hidden = false;
          } else {
            pvCompare.hidden = true;
          }
        }
        if(pvLink) pvLink.setAttribute('href', data.url || '#');
        preview.hidden = false;
      }

      function hidePreview(){
        if(preview) preview.hidden = true;
      }

      function update(){
        slides.forEach((s,i)=> s.classList.toggle('is-active', i===index));
        thumbs.forEach((t,i)=> t.classList.toggle('is-active', i===index));
        if(legend){
          const groups = legend.querySelectorAll('.hsx-legend-group');
          groups.forEach((g,i)=> g.classList.toggle('is-active', i===index));
        }
        if(pageCountEl) pageCountEl.textContent = (root.getAttribute('data-page-label') || 'Page') + ' ' + (index+1) + ' / ' + total;

        if(pageTitleEl){
          const activeSlide = slides[index];
          const title = activeSlide ? activeSlide.getAttribute('data-title') : '';
          pageTitleEl.textContent = title || '';
        }

        hidePreview();
      }

      function goto(i){
        if(total === 0) return;
        index = (i + total) % total;
        update();
      }

      openBtn && openBtn.addEventListener('click', openModal);
      closeBtn && closeBtn.addEventListener('click', closeModal);
      pvClose && pvClose.addEventListener('click', hidePreview);

      if(modal){
        modal.addEventListener('click', (e)=>{
          if(e.target === modal) closeModal();
        });
        modal.addEventListener('close', ()=>{
          lockScroll(false);
          hidePreview();
        });
      }

      function onKey(e){
        const isOpen = modal && (modal.open || modal.hasAttribute('open'));
        if(!isOpen) return;

        if(e.key==='Escape'){
          e.preventDefault();
          if(preview && !preview.hidden){ hidePreview(); return; }
          closeModal();
        }
        if(e.key==='ArrowRight'){ e.preventDefault(); goto(index+1); }
        if(e.key==='ArrowLeft'){ e.preventDefault(); goto(index-1); }

        if(e.key==='Tab'){
          const focusables = modal.querySelectorAll('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
          const list = Array.from(focusables).filter(el => !el.hasAttribute('disabled') && el.offsetParent !== null);
          if(list.length===0) return;
          const first = list[0], last = list[list.length-1];
          if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
          else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
        }
      }
      document.addEventListener('keydown', onKey);

      prevBtn && prevBtn.addEventListener('click', ()=> goto(index-1));
      nextBtn && nextBtn.addEventListener('click', ()=> goto(index+1));
      prevMini && prevMini.addEventListener('click', ()=> goto(index-1));
      nextMini && nextMini.addEventListener('click', ()=> goto(index+1));
      thumbs.forEach((t)=>{
        t.addEventListener('click', ()=>{
          const n = parseInt(t.getAttribute('data-x-goto'), 10);
          if(!isNaN(n)) goto(n-1);
        });
      });

      root.querySelectorAll('.hsx-dot[href]').forEach(dot=>{
        dot.addEventListener('click', (e)=>{
          const isProduct = dot.getAttribute('data-x-product') === 'true';
          if(!isProduct || e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
          e.preventDefault();
          showPreview({
            title: dot.getAttribute('data-title') || '',
            url: dot.getAttribute('data-url') || dot.getAttribute('href') || '#',
            image: dot.getAttribute('data-image') || '',
            price: dot.getAttribute('data-price') || '',
            compare: dot.getAttribute('data-compare') || ''
          });
        });
      });

      let startX = 0, startY = 0, isTouch = false;
      const area = root.querySelector('.hsx-carousel');
      area && area.addEventListener('touchstart', (e)=>{
        isTouch = true;
        const t = e.changedTouches[0];
        startX=t.clientX; startY=t.clientY;
      }, {passive:true});
      area && area.addEventListener('touchend', (e)=>{
        if(!isTouch) return;
        const t=e.changedTouches[0];
        const dx=t.clientX-startX;
        const dy=t.clientY-startY;
        if(Math.abs(dx)>40 && Math.abs(dx)>Math.abs(dy)){
          if(dx<0) goto(index+1);
          else goto(index-1);
        }
        isTouch=false;
      }, {passive:true});

      if(total <= 1){
        prevBtn && (prevBtn.hidden = true);
        nextBtn && (nextBtn.hidden = true);
        prevMini && (prevMini.hidden = true);
        nextMini && (nextMini.hidden = true);
      }
    
  }
  function initAll(scope){
    var c=scope&&scope.querySelectorAll?scope:document;
    c.querySelectorAll('.hsx[id^="hotspot-carousel-"]').forEach(init);
    if(scope&&scope.matches&&scope.matches('.hsx[id^="hotspot-carousel-"]')) init(scope);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){initAll(document);},{once:true}); else initAll(document);
  document.addEventListener('shopify:section:load',function(e){initAll(e.target);});
})();

  } catch(e) { console.error(e); }
})();
})();
